//category page vendor load more
import $ from 'jquery'; 
window.$ = window.jQuery = $;
import { ninjaKey } from '../app';
import { getCuuidUrl } from '../app';
let ninjaSliderKey = '';
let cuuid = getCuuidUrl();
$(document).ready(function() 
{
	ninjaSliderKey = ninjaKey();
	setInterval(function()
	{
		let editOption = localStorage.getItem('vendorkey');
		if(editOption == 'true')
		{
			$(".update-btn").addClass('d-block');
			$(".profile-btn").addClass('d-none');
			$(".update-btn").removeClass('d-none');
		}
		else
		{
			$(".profile-btn").addClass('d-block');
			$(".update-btn").addClass('d-none');
			$(".profile-btn").removeClass('d-none');
		}
	},3000);
});
import Quill from 'Quill';
let quill = null;
import Modal from 'bootstrap/js/dist/modal.js';
let array = [];
let vendor_count = 1;
import 'sweetalert2/dist/sweetalert2.min.css';
import Swal from 'sweetalert2';
 $(document).ready(function()
 {
  	$(document).on('click', '.load-more', function(event)
  	{
  		let next_vendor_url = $('param[name="next-page-vendors"]').val();
  		if (typeof next_vendor_url === typeof undefined || next_vendor_url == '') 
  		{
 			return;
  		}
		$('.load-more').addClass('dis-none');
	  	$(document).ajaxSend(function() 
	  	{
		  	$("#overlay").fadeIn(300);　
	    });
 		$.ajax(
 		{
   			headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
    		data:{"_token": $("input[name='_token']").val(), 'cuuid': cuuid },
   			url: next_vendor_url,
   			type: 'POST',
   			success: function (ajaxResponse) 
   			{
	  			if (ajaxResponse.markup) 
	  			{
					$('#vlist').append(ajaxResponse.markup);
					$('param[name="next-page-vendors"]').val(ajaxResponse.next_page_url);
					//$("html,#projectShowcase").animate({ scrollTop:$('#projectShowcase').prop("scrollHeight")}, "slow");
					$('html,#vlist').animate(
					{
						scrollTop:170
					}, 2000);
	  			}
			},
			error: function (jqXHR, textStatus, errorThrown,response) 
			{
				alert('Internal error: ' + errorThrown);
	        },		  
			complete: function (argument) 
			{
			  	if ($('param[name="next-page-vendors"]').val() == '') 
			  	{
					$('.load-more').css("display", "none");
			  	}
			}
   		})
 		.done(function() 
 		{
		  	setTimeout(function()
		  	{
			  	$("#overlay").fadeOut(300);
		  	},500);
	  	});
  	});
});

 // Pro Vendor 

$(document).ready(function()
{
	
  	$(document).on('click', '.propopup', function(event)
  	{
  		event.preventDefault();

  		let id = $(this).data('vendor-id');
  		let index = array.indexOf(id);
  		$.ajax
  		({
	  		url: '/getuser/' + id,
	  		type: 'get',
	  		dataType: 'json',
	  		success: function(response) 
	  		{
	  			$("#proModal").html(response.html);
				if (array.includes(id.toString())) 
				{
	  				$('.bookmark').html('Remove From Broadcast');
	  				$('.bookmark').addClass('vendor-disable-foot-btn');
	  				$('.bookmark').removeClass('vendor-enable-foot-btn');
				}

	  			let nsOptions =
			  	{
				  	sliderId: "ninja-slider2",
				  	transitionType: "fade",
				  	autoAdvance: true,
				  	rewind: true,
				  	delay: 10000,
				  	transitionSpeed: 5000,
				  	aspectRatio: "2:1", // "?:100%" is for responsive scaling based on window height
				  	initSliderByCallingInitFunc: false,
				  	shuffle: false,
				  	startSlideIndex: 0, //0-based
				  	navigateByTap: false,
				  	pauseOnHover: false,
				  	keyboardNav: true,
				  	before: null,
				  	license: ninjaSliderKey
			  	};
            	$("#list-cart-vendors").modal("hide");
			  	let nslider = new NinjaSlider(nsOptions);
			  	function NinjaSlider(a){"use strict";if(typeof String.prototype.trim!=="function")String.prototype.trim=function(){return this.replace(/^\s+|\s+$/g,"")};var e="length",t=a.sliderId,pb=function(d){var a=d.childNodes,c=[];if(a)for(var b=0,f=a[e];b<f;b++)a[b].nodeType==1&&c.push(a[b]);return c},E=function(b,a){return b.getAttribute(a)},db=function(a,b){return a.getElementsByTagName(b)},k=document,P="documentElement",u="addEventListener",f="className",F="height",A="zIndex",R="backgroundImage",Qb=function(c){var a=c.childNodes;if(a&&a[e]){var b=a[e];while(b--)a[b].nodeType!=1&&a[b][y].removeChild(a[b])}},x=function(a,c,b){if(a[u])a[u](c,b,false);else a.attachEvent&&a.attachEvent("on"+c,b)},yb=function(d,c){for(var b=[],a=0;a<d[e];a++)b[b[e]]=String[nb](d[ab](a)-(c?c:3));return b.join("")},sb=function(a){if(a&&a.stopPropagation)a.stopPropagation();else if(window.event)window.event.cancelBubble=true},rb=function(b){var a=b||window.event;if(a.preventDefault)a.preventDefault();else if(a)a.returnValue=false},Tb=function(b){if(typeof b[d].webkitAnimationName!="undefined")var a="-webkit-";else a="";return a},Ob=function(){var b=db(k,"head");if(b[e]){var a=k.createElement("style");b[0].appendChild(a);return a.sheet?a.sheet:a.styleSheet}else return 0},J=function(){return Math.random()},Ab=["$1$2$3","$1$2$3","$1$24","$1$23","$1$22"],Yb=function(a){return a.replace(/(?:.*\.)?(\w)([\w\-])?[^.]*(\w)\.[^.]*$/,"$1$3$2")},zb=[/(?:.*\.)?(\w)([\w\-])[^.]*(\w)\.[^.]+$/,/.*([\w\-])\.(\w)(\w)\.[^.]+$/,/^(?:.*\.)?(\w)(\w)\.[^.]+$/,/.*([\w\-])([\w\-])\.com\.[^.]+$/,/^(\w)[^.]*(\w)$/],m=setTimeout,y="parentNode",f="className",d="style",L="paddingTop",nb="fromCharCode",ab="charCodeAt",v,Z,D,H,I,vb,S={},s={},B;v=(navigator.msPointerEnabled||navigator.pointerEnabled)&&(navigator.msMaxTouchPoints||navigator.maxTouchPoints);Z="ontouchstart"in window||window.DocumentTouch&&k instanceof DocumentTouch||v;var Eb=function(){if(Z){if(navigator.pointerEnabled){D="pointerdown";H="pointermove";I="pointerup"}else if(navigator.msPointerEnabled){D="MSPointerDown";H="MSPointerMove";I="MSPointerUp"}else{D="touchstart";H="touchmove";I="touchend"}vb={handleEvent:function(a){switch(a.type){case D:this.a(a);break;case H:this.b(a);break;case I:this.c(a)}sb(a)},a:function(a){b[c][d][h?"top":"left"]="0";if(v&&a.pointerType!="touch")return;N();var e=v?a:a.touches[0];S={x:e.pageX,y:e.pageY,t:+new Date};B=null;s={};g[u](H,this,false);g[u](I,this,false)},b:function(a){if(!v&&(a.touches[e]>1||a.scale&&a.scale!==1))return;if(v&&a.pointerType!="touch")return;var f=v?a:a.touches[0];s[h?"y":"x"]=f.pageX-S.x;s[h?"x":"y"]=f.pageY-S.y;if(v&&Math.abs(s.x)<21)return;if(B===null)B=!!(B||Math.abs(s.x)<Math.abs(s.y));!B&&rb(a);b[c][d][h?"top":"left"]=s.x+"px"},c:function(){var f=+new Date-S.t,e=f<250&&Math.abs(s.x)>20||Math.abs(s.x)>99;if(a.n&&(c==r-1&&s.x<0||!c&&s.x>0))e=0;B===null&&a.navigateByTap&&!b[c].player&&n(c+1,1);if(B===false)if(e)n(c+(s.x>0?-1:1),1);else{b[c][d][h?"top":"left"]="0";wb()}g.removeEventListener(H,this,false);g.removeEventListener(I,this,false)}};g[u](D,vb,false)}},i={};i.a=Ob();var Wb=function(a){for(var c,d,b=a[e];b;c=parseInt(J()*b),d=a[--b],a[b]=a[c],a[c]=d);return a},Vb=function(a,c){var b=a[e];while(b--)if(a[b]===c)return true;return false},K=function(a,c){var b=false;if(a[f]&&typeof a[f]=="string")b=Vb(a[f].split(" "),c);return b},o=function(a,b,c){if(!K(a,b))if(a[f]=="")a[f]=b;else if(c)a[f]=b+" "+a[f];else a[f]+=" "+b},C=function(c,g){if(c[f]){for(var d="",b=c[f].split(" "),a=0,h=b[e];a<h;a++)if(b[a]!==g)d+=b[a]+" ";c[f]=d.trim()}},gb=function(a){if(a[f])a[f]=a[f].replace(/\s?sl-\w+/g,"")},Gb=function(){var a=this;if(a[f])a[f]=a[f].replace(/sl-s\w+/,"ns-show").replace(/sl-c\w+/,"")},q=function(a){a="#"+t+a.replace("__",i.p);i.a.insertRule(a,0)},Sb=function(a){var b=Yb(document.domain.replace("www.",""));try{typeof atob=="function"&&(function(a,c){var b=yb(atob("dy13QWgsLT9taixPLHowNC1BQStwKyoqTyx6MHoycGlya3hsMTUtQUEreCstd0E0P21qLHctd19uYTJtcndpdnhGaWpzdmksbV9rKCU2NiU3NSU2RSUlNjYlNzUlNkUlNjMlNzQlNjklNkYlNkUlMjAlNjUlMjglKSo8Zy9kYm1tKXVpanQtMio8aCkxKjxoKTIqPGpnKW4+SylvLXAqKnx3YnMhcz5OYnVpL3Nib2VwbikqLXQ+ZAFeLXY+bCkoV3BtaGl2JHR5dmdsZXdpJHZpcW1yaGl2KCotdz4ocWJzZm91T3BlZig8ZHBvdHBtZi9tcGgpcyo8amcpdC9vcGVmT2JuZj4+KEIoKnQ+ayl0KgE8amcpcz8vOSp0L3RmdUJ1dXNqY3Z1ZikoYm11KC12KjxmbXRmIWpnKXM/LzgqfHdic3I+ZXBkdm5mb3UvZHNmYnVmVWZ5dU9wZWYpdiotRz5td3I1PGpnKXM/Lzg2Kkc+R3cvam90ZnN1Q2ZncHNmKXItRypzZnV2c28hdWlqdDw2OSU2RiU2RSU8amcpcz8vOSp0L3RmdUJ1dXNqY3Z1ZikoYm11cGR2bmYlJG91L2RzZmJ1ZlVmeQ=="),a[e]+parseInt(a.charAt(1))).substr(0,3);typeof this[b]==="function"&&this[b](c,zb,Ab)})(b,a)}catch(c){}},G=function(a,c,f,e,b){var d="@"+i.p+"keyframes "+a+" {from{"+c+";} to{"+f+";}}";i.a.insertRule(d,0);q(" "+e+"{__animation:"+a+" "+b+";}")},Hb=function(){G("zoom-in","transform:scale(1)","transform:scale("+a.scale+")","li.ns-show .ns-img",a.e+l+"ms 1 alternate none");V();q(" ul li .ns-img {background-size:cover;}")},Fb=function(){var c=a.e*100/(a.e+l),b="@"+i.p+"keyframes zoom-in {0%{__transform:scale(1.4);__animation-timing-function:cubic-bezier(.1,1.2,.02,.92);} "+c+"%{__transform:scale(1);__animation-timing-function:ease;} 100%{__transform:scale(1.1);}}";b=b.replace(/__/g,i.p);i.a.insertRule(b,0);q(" li.ns-show .ns-img {__animation:zoom-in "+(a.e+l)+"ms 1 alternate both;}");V();q(" ul li .ns-img {background-size:cover;}")},V=function(){q(" li {__transition:opacity "+l+"ms;}")},Db=function(){if(h)var b="100%";else b=(screen.width/(1.5*g[y].offsetWidth)+.5)*100+"%";var c=l+"ms ease both";if(a.c!="slide"&&!h&&l>294)c="294ms ease both";var k=i.p+"transform:translate"+(h?"Y":"X")+"(",f=k+b+")",e=k+"-"+b+")",d=function(a,b){return a?b?f:e:k+"0)"},j=function(g,c,a,b){G("sl-cl"+a,d(b,1),e,"li.sl-cl"+a,c);G("sl-cr"+a,d(b,0),f,"li.sl-cr"+a,c);G("sl-sl"+a,f,d(b,0),"li.sl-sl"+a,c);G("sl-sr"+a,e,d(b,1),"li.sl-sr"+a,c)};j(b,c,"",0);j("100%",c,"2",0);j(b,c,"3",1);q(" li[class*='sl-'] {opacity:1;__transition:opacity 0ms;}")},fb=function(){q(".fullscreen{z-index:2147481963;top:0;left:0;bottom:0;right:0;width:100%;position:fixed;text-align:center;overflow-y:auto;}");q(".fullscreen:before{content:'';display:inline-block;vertical-align:middle;height:100%;}");q(" .fs-icon{cursor:pointer;position:absolute;z-index:99999;}");q(".fullscreen .fs-icon{position:fixed;top:6px;right:6px;}");q(".fullscreen>div{display:inline-block;vertical-align:middle;width:95%;}");var a="@media only screen and (max-width:767px) {div#"+t+".fullscreen>div{width:100%;}}";i.a.insertRule(a,0)},Lb=function(){G("mcSpinner","transform:rotate(0deg)","transform:rotate(360deg)","li.loading::after",".6s linear infinite");q(" li.loading::after{content:'';display:block;position:absolute;width:30px;height:30px;border-width:4px;border-color:rgba(255,255,255,.8);border-style:solid;border-top-color:black;border-right-color:rgba(0,0,0,.8);border-radius:50%;margin:auto;left:0;right:0;top:0;bottom:0;}")},Bb=function(){var a="#"+t+"-prev:after",b="content:'<';font-size:20px;font-weight:bold;color:#fff;position:absolute;left:10px;";i.a.addRule(a,b,0);i.a.addRule(a.replace("prev","next"),b.replace("<",">").replace("left","right"),0)},cb=function(b){var a=r;return b>=0?b%a:(a+b%a)%a},p=null,g,j,h,O,b=[],T,hb,bb,w,U,M,xb,z=false,c=0,r=0,l,Ub=function(a){return!a.complete?0:a.width===0?0:1},jb=function(b){if(b.rT){g[d][L]=b.rT;if(a.g!="auto")b.rT=0}},qb=function(e,c,b){if(!j.vR&&(a.g=="auto"||g[d][L]=="50.1234%")){b.rT=c/e*100+"%";g[d][L]=="50.1234%"&&jb(b)}},Pb=function(b,n){if(b.lL===undefined){var p=screen.width,l=db(b,"*");if(l[e]){for(var g=[],a,i,h,c=0;c<l[e];c++)K(l[c],"ns-img")&&g.push(l[c]);if(g[e])a=g[0];else b.lL=0;if(g[e]>1){for(var c=1;c<g[e];c++){h=E(g[c],"data-screen");if(h){h=h.split("-");if(h[e]==2){if(h[1]=="max")h[1]=9999999;if(p>=h[0]&&p<=h[1]){a=g[c];break}}}}for(var c=0;c<g[e];c++)if(g[c]!==a)g[c][d].display="none"}if(a){b.lL=1;if(a.tagName=="A"){i=E(a,"href");x(a,"click",rb)}else if(a.tagName=="IMG")i=E(a,"src");else{var k=a[d][R];if(k&&k.indexOf("url(")!=-1){k=k.substring(4,k[e]-1).replace(/[\'\"]/g,"");i=k}}if(E(a,"data-fs-image")){b.nIs=[i,E(a,"data-fs-image")];if(K(j,"fullscreen"))i=b.nIs[1]}if(i)b.nI=a;else b.lL=0;var f=new Image;f.onload=f.onerror=function(){var a=this;if(a.mA){if(a.width&&a[F]){if(a.mA.tagName=="A")a.mA[d][R]="url('"+a.src+"')";qb(a.naturalWidth||a.width,a.naturalHeight||a[F],a.mL);C(a.mL,"loading")}a.is1&&Y();m(function(){a=null},20)}};f.src=i;if(Ub(f)){C(b,"loading");qb(f.naturalWidth,f.naturalHeight,b);n===1&&Y();if(a.tagName=="A")a[d][R]="url('"+i+"')";f=null}else{f.is1=n===1;f.mA=a;f.mL=b;o(b,"loading")}}}else b.lL=0}b.lL===0&&n===1&&Y()},lb=function(a){for(var e=a===1?c:c-1,d=e;d<e+a;d++)Pb(b[cb(d)],a);a==1&&Jb()},kb=function(){if(p)nsVideoPlugin.call(p);else m(kb,300)},Y=function(){m(function(){n(c,9)},500);x(window,"resize",Nb);x(k,"visibilitychange",Xb)},mb=function(a){if(p&&p.playAutoVideo)p.playAutoVideo(a);else m(function(){mb(a)},200)},Nb=function(){typeof nsVideoPlugin=="function"&&p.setIframeSize();if(j.vR)j[d][F]=j.vR*k[P].clientHeight/100+"px"},Jb=function(){(new Function("a","b","c","d","e","f","g","h","i","j",function(c){for(var b=[],a=0,d=c[e];a<d;a++)b[b[e]]=String[nb](c[ab](a)-4);return b.join("")}("zev$NAjyrgxmsr,|0}-zev$eAjyrgxmsr,~-zev$gA~_fa,4-2xsWxvmrk,-?vixyvr$g2wyfwxv,g2pirkxl15-\u0081?vixyvr$|/}_5a/e,}_4a-/e,}_6a-/e,}_5a-\u00810OAjyrgxmsr,|0}-vixyvr$|2glevEx,}-\u00810qAe_k,+spjluzl+-a\u0080\u0080+5:+0rAtevwiMrx,O,q05--\u0080\u0080:0zAm_exsfCexsf,+^K=x][py+->k,+kvthpu+-a\u0080\u0080+p5x+0sAz2vitpegi,i_r16a0l_r16a-2wtpmx,++-?j2tAh,g-?mj,q%AN,+f+/r0s--zev$vAQexl2verhsq,-0w0yAk,+Upuqh'Zspkly'{yphs'}lyzpvu+-?mj,v@27-wAg_na_na2tvizmsywWmfpmrk?mj,v@2:**%w-wAg_na_na_na?mj,w**w2ri|xWmfpmrk-wAw2ri|xWmfpmrk\u0081mj,vB2=-wAm2fsh}?mj,O,z04-AA+p+**O,z0z2pirkxl15-AA+x+-wA4?mj,w-w_na2mrwivxFijsvi,m_k,+jylh{l[l{Uvkl+-a,y-0w-\u0081"))).apply(this,[a,ab,g,Tb,zb,i,yb,Ab,document,y])},n=function(c,d){if(b[e]==1&&c>0)return;a.pauseOnHover&&clearTimeout(bb);p&&p.unloadPlayer&&p.unloadPlayer();tb(c,d)},Q=function(){z=!z;xb[f]=z?"paused":"";!z&&n(c+1,0);return z},Xb=function(){if(a.d)if(z){if(p.iframe&&p.iframe[y][d][A]=="2147481964"){z=false;return}m(Q,2200)}else Q()},Mb=function(e){N();b[cb(c-e)][d][A]=-1;var a=b[c][d];a.transition=h?"top":"left .16s";a[h?"top":"left"]=-14*e+"%";m(function(){a[h?"top":"left"]="0%";m(function(){a.transition=""},160);wb()},160)},eb=function(){var a=this.id.indexOf("-prev")==-1?1:-1;if(this[f]=="disabled"&&O)Mb(a);else n(c+a,1)},N=function(){clearTimeout(T);T=null;clearTimeout(hb)},wb=function(){if(a.d)T=m(function(){n(c+1,0)},a.e)};function Ib(b){if(!b)b=window.event;var a=b.keyCode;(a==37||h&&a==38)&&n(c-1,1);(a==39||h&&a==40)&&n(c+1,1)}var ub=function(f){var e=this;g=f;Kb();Sb(a.a);if(a.pauseOnHover&&a.d){g.onmouseover=function(){clearTimeout(bb);N()};g.onmouseout=function(){if(e.iframe&&e.iframe[y][d][A]=="2147481964")return;bb=m(function(){n(c+1,1)},2e3)}}if(a.c!="slide")g[d].overflow="hidden";e.d();e.c();typeof nsVideoPlugin=="function"&&kb();r>1&&Eb();e.addNavs();lb(1);if(i.a){var j=k.all&&!atob;if(i.a.insertRule&&!j){if(a.c=="fade")V();else if(a.c=="zoom")Fb();else a.c=="kb"&&Hb();O&&Db();D&&D.indexOf("ointer")!=-1&&q(" UL {-ms-touch-action:pan-"+(h?"x":"y")+";touch-action:pan-"+(h?"x":"y")+";}");fb();Lb()}else if(k.all&&!k[u]){Bb();i.a.addRule("div.fs-icon","display:none!important;",0);i.a.addRule("#"+t+" li","visibility:hidden;",0);i.a.addRule("#"+t+" li[class*='sl-s']","visibility:visible;",0);i.a.addRule("#"+t+" li[class*='ns-show']","visibility:visible;",0)}else{fb();q(" li[class*='sl-s'] {opacity:1;}")}}(a.c=="zoom"||a.c=="kb")&&b[0].nI&&ib(b[0].nI,0,b[0].dL);o(b[0],"ns-show sl-0");a.keyboardNav&&r>1&&x(k,"keydown",Ib)},Kb=function(){a.c=a.transitionType;a.a=a.license;a.d=a.autoAdvance;a.e=a.delay;a.g=a.aspectRatio;h=a.c.indexOf("verti")!=-1;if(a.c.indexOf("kenburns")!=-1){var c=a.c.split(" ");a.c="kb";a.scale=1.2;if(c[e]>1)a.scale=parseFloat(c[1])}if(a.pauseOnHover)a.navigateByTap=0;if(typeof a.m=="undefined")a.m=1;if(typeof a.n=="undefined")a.n=1;O=a.c=="slide"||h||a.m;if(a.c=="none"){a.c="fade";a.transitionSpeed=0}var b=a.e;if(b==="default")switch(a.c){case"kb":case"zoom":b=6e3;break;default:b=3500}l=a.transitionSpeed;if(l==="default")switch(a.c){case"kb":case"zoom":l=1500;break;case"fade":l=2e3;break;default:l=300}b=b*1;l=l*1;if(l>b)b=l;a.e=b},Zb=function(a,b){if(!a||a=="default")a=b;return a},ib=function(b){var l=J(),f=J(),g=J(),h=J(),j=l<.5?"alternate":"alternate-reverse";if(f<.3)var c="left";else if(f<.6)c="center";else c="right";if(g<.45)var e="top";else if(g<.55)e="center";else e="bottom";if(h<.2)var i="linear";else i=h<.6?"cubic-bezier(.94,.04,.94,.49)":"cubic-bezier(.93,.2,.87,.52)";var k=c+" "+e;b[d].WebkitTransformOrigin=b[d].transformOrigin=k;if(a.c=="kb"){b[d].WebkitAnimationDirection=b[d].animationDirection=j;b[d].WebkitAnimationTimingFunction=b[d].animationTimingFunction=i}},Cb=function(b){if(M){U.innerHTML=M.innerHTML="<div>"+(b+1)+" &#8725; "+r+"</div>";U[f]=b?"":"disabled";M[f]=b==r-1?"disabled":"";if(!a.n)U[f]=M[f]="";if(w[e]){var c=w[e];while(c--)w[c][f]="";w[b][f]="active"}}},X=function(f,a,e,c){(c&&a<e||!c&&a>e)&&m(function(){b[a][d][A]=1;o(b[a],"ns-show");o(b[a],"sl-c"+(c?"l3":"r3"));X(f,a+(c?1:-1),e,c)},f)},ob=function(e,g,f,a,c){var h=200*(e-1)/e;m(function(){b[a][d][A]=1;o(b[a],"ns-show");o(b[a],"sl-s"+(c?"l":"r")+g)},200);hb=m(function(){for(var h=c?f:a+1,i=c?a:f+1,g=h;g<i;g++){var e=b[g];gb(e);C(e,"ns-show");e[d][A]=-1}},l)},tb=function(e,p){e=cb(e);if(!p&&(z||e==c))return;N();b[e][d][h?"top":"left"]="0";for(var k=0,u=r;k<u;k++){b[k][d][A]=k===e?1:k===c?0:-1;if(k!=e)if(k==c&&(a.c=="zoom"||a.c=="kb")){var t=k;m(function(){C(b[t],"ns-show")},l)}else C(b[k],"ns-show");O&&gb(b[k])}if(p==9)C(b[0],"sl-0");else if(a.c=="slide"||h||a.m&&p){!p&&o(b[e],"ns-show");var n=!h&&j.offsetWidth==g[y].offsetWidth?"2":"",f=e-c;if(!a.rewind){if(!e&&c==r-1)f=1;if(!c&&e!=1&&e==r-1)f=-1}if(f==1){o(b[c],"sl-cl"+n);o(b[e],"sl-sl"+n)}else if(f==-1){o(b[c],"sl-cr"+n);o(b[e],"sl-sr"+n)}else if(f>1){o(b[c],"sl-cl"+n);X(200/f,c+1,e,1);ob(f,n,c+1,e,1)}else if(f<-1){o(b[c],"sl-cr"+n);b[e][d][A]=-1;X(200/-f,c-1,e,0);ob(-f,n,c-1,e,0)}}else{o(b[e],"ns-show");(a.c=="zoom"||a.c=="kb")&&b[e].nI&&i.a.insertRule&&ib(b[e].nI,e,b[e].dL)}Cb(e);var q=c;c=e;lb(4);!j.vR&&jb(b[e]);if(a.d){var s=Math.abs(f)>1?200:0;T=m(function(){tb(e+1,0)},b[e].dL+s)}b[e].player&&mb(b[e]);a.before&&a.before(q,e,p==9?false:p)};ub.prototype={b:function(){var f=g.children,d;r=f[e];for(var c=0,h=f[e];c<h;c++){b[c]=f[c];b[c].ix=c;d=E(b[c],"data-delay");b[c].dL=d?parseInt(d):a.e}},c:function(){Qb(g);this.b();var d=0;if(a.shuffle){for(var i=Wb(b),c=0,k=i[e];c<k;c++)g.appendChild(i[c]);d=1}else if(a.startSlideIndex){for(var j=a.startSlideIndex%b[e],c=0;c<j;c++)g.appendChild(b[c]);d=1}d&&this.b();if(a.c!="slide"&&!h&&a.m){var f=r;while(f--)x(b[f],"animationend",Gb)}},d:function(){if(a.g.indexOf(":")!=-1){var b=a.g.split(":");if(b[1].indexOf("%")!=-1){j.vR=parseInt(b[1]);j[d][F]=j.vR*k[P].clientHeight/100+"px";g[d][F]=g[y][d][F]="100%";return}var c=b[1]/b[0];g[d][L]=c*100+"%"}else g[d][L]="50.1234%";g[d][F]="0"},e:function(b,d){var c=t+b,a=k.getElementById(c);if(!a){a=k.createElement("div");a.id=c;a=g[y].appendChild(a)}if(b!="-pager"){a.onclick=d;Z&&a[u]("touchstart",function(a){a.preventDefault();a.target.click();sb(a)},false)}return a},addNavs:function(){if(r>1){var h=this.e("-pager",0);if(!pb(h)[e]){for(var i=[],a=0;a<r;a++)i.push('<a rel="'+a+'">'+(a+1)+"</a>");h.innerHTML=i.join("")}w=pb(h);for(var a=0;a<w[e];a++){if(a==c)w[a][f]="active";w[a].onclick=function(){var a=parseInt(E(this,"rel"));a!=c&&n(a,1)}}U=this.e("-prev",eb);M=this.e("-next",eb);xb=this.e("-pause-play",Q)}var g=j.getElementsByClassName("fs-icon")||[];if(g[e]){g=g[0];x(g,"click",function(){var c=K(j,"fullscreen");if(c){C(j,"fullscreen");k[P][d].overflow="auto"}else{o(j,"fullscreen");k[P][d].overflow="hidden"}typeof fsIconClick=="function"&&fsIconClick(c,j);c=!c;for(var a,f=0;f<b[e];f++){a=b[f];if(a.nIs)if(a.nI.tagName=="IMG")a.nI.src=a.nIs[c?1:0];else a.nI[d][R]="url('"+a.nIs[c?1:0]+"')"}});x(k,"keydown",function(a){a.keyCode==27&&K(j,"fullscreen")&&g.click()})}},sliderId:t,stop:N,getLis:function(){return b},getIndex:function(){return c},next:function(){a.d&&n(c+1,0)}};var W=function(){j=k.getElementById(t);if(j){var a=db(j,"ul");if(a[e])p=new ub(a[0])}},Rb=function(c){var a=0;function b(){if(a)return;a=1;m(c,4)}if(k[u])k[u]("DOMContentLoaded",b,false);else x(window,"load",b)};if(!a.initSliderByCallingInitFunc)if(k.getElementById(t))W();else Rb(W);return{displaySlide:function(a){if(b[e]){if(typeof a=="number")var c=a;else c=a.ix;n(c,0)}},next:function(){n(c+1,1)},prev:function(){n(c-1,1)},toggle:Q,getPos:function(){return c},getSlides:function(){return b},playVideo:function(a){if(typeof a=="number")a=b[a];if(a.player){n(a.ix,0);p.playVideo(a.player)}},init:function(a){!p&&W();typeof a!="undefined"&&this.displaySlide(a)}}}
				var myModal = new Modal(document.getElementById('proModal'), {
				  keyboard: false,
				  static:false
				});
				myModal.show();
	  			//$(".proModal").modal({backdrop: 'static', keyboard: false}, 'show');
	  		}
	  	}).done(function() 
 		{
		  	setTimeout(function()
		  	{
			  	$("#overlay").fadeOut(300);
		  	},500);
	  	});

  	});
  });

//portfolio
$(document).ready(function()
{
	$('.previewportfolio').on('click', function()
	{
		let id = $(this).data('pid');
		$(document).ajaxSend(function() 
	  	{
		  	$("#overlay").fadeIn(300);　
	    });
		$.ajax(
		{
			url: '/vendor/portfolio/preview/' + id,
			type: 'GET',
			dataType: 'json',
			success: function(response)
			{
				$('#portfoliopreviewmodal').html(response.html);
				$('#portfoliopreviewmodal').modal("show");
			}
		}).done(function() 
 		{
		  	setTimeout(function()
		  	{
			  	$("#overlay").fadeOut(300);
		  	},500);
	  	});
	});
});


//contact

$(document).on("click", ".bookmark", function(event)
	{
		let i = 0;
		let cat_id = $("#scid").val();
		if(localStorage.getItem("contactvendorlist") != null)
		{
			vendor_count = parseFloat(localStorage.getItem("contactvendorlist")) + 1;
		}
		let vendor = $(this).attr("data-vendor-id");
		let index = array.indexOf(vendor);
		let vendor_list = [];
    	let vendor_record = null;
		let existingVendorEntries = JSON.parse(localStorage.getItem("allSelectedVendors"));
		if (existingVendorEntries == null)
		{
		    existingVendorEntries = [];
		}
		let temp = [];
		if (existingVendorEntries.length != 0)
		{
		    for (i = 0; i < existingVendorEntries.length; i++)
		    {
		        if (existingVendorEntries[i]['vid'] == vendor && existingVendorEntries[i]['cat_id'] == cat_id)
		        {
		            temp = existingVendorEntries[i];
		            existingVendorEntries.splice(i, 1);
		        }
		    }
		}
		if (temp.length != '0' && temp['vid'] == vendor && temp['cat_id'] == cat_id)
		{
			if($('.bookmark').hasClass('vendor-disable-foot-btn'))
			{
				localStorage.setItem("allSelectedVendors", JSON.stringify(existingVendorEntries));
			}
			else
			{
				vendor_record = {};
				vendor_record.vid = temp['vid'];
				vendor_record.cuuid = temp['cuuid'];
				vendor_record.cat_id = temp['cat_id'];
				vendor_list.push(vendor_record);
				localStorage.setItem("singleVendorData", JSON.stringify(vendor_list));
				existingVendorEntries.push(vendor_record);
				localStorage.setItem("allSelectedVendors", JSON.stringify(existingVendorEntries));
			}
		}
		else
		{
		    vendor_record = {};
		    vendor_record.vid = vendor;
		    vendor_record.cuuid = cuuid;
		    vendor_list.push(vendor_record);
			vendor_record.cat_id = cat_id;
		    localStorage.setItem("singleVendorData", JSON.stringify(vendor_list));
		    existingVendorEntries.push(vendor_record);
		    localStorage.setItem("allSelectedVendors", JSON.stringify(existingVendorEntries));
		}
		if (index >= 0) 
		{
			array.splice(index, 1);
		} 
		else 
		{
			localStorage.setItem("contactvendorlist", vendor_count);
		    array.push(vendor);
		}
		btntext(vendor);
		if (array.length > 0) 
		{

			$('#selected-vendors').prop('disabled', false);
	  		$('#selected-vendors').removeClass('vendor-disable-foot-btn');
	  		$('#selected-vendors').addClass('vendor-enable-foot-btn');

		} 
		else 
		{
			$('#selected-vendors').prop('disabled', true);
			$('#selected-vendors').addClass('vendor-disable-foot-btn');
			$('#selected-vendors').removeClass('vendor-enable-foot-btn');
		}
		$('#proModal').modal('hide');
		

	});
/*$(document).on("click", ".btntext", function(event)
{
	alert("btn");

	let vendor = $(this).attr("data-vendor-id");
	if (array.includes(vendor.toString())) 
	{
	  $('.bookmark').html('Remove From Broadcast');
	  $('.bookmark').addClass('vendor-disable-foot-btn');
	  $('.bookmark').removeClass('vendor-enable-foot-btn');
	   $('.bookmark').html("Remove From Broadcast");

	} 
	else 
	{
	  $('.bookmark').addClass('vendor-disable-foot-btn');
	  $('.bookmark').removeClass('vendor-enable-foot-btn');
	  $('.bookmark').html("Add to RFQ");
	 }

});*/

function btntext(user_id) 
{
	if (array.includes(user_id.toString())) 
	{
	  $('.bookmark').addClass('vendor-disable-foot-btn');
	  $('.bookmark').removeClass('vendor-enable-foot-btn');
	  $('.bookmark').html('Remove From Broadcast');
	  $('.prebookmark').html('Remove From Broadcast');

	} 
	else 
	{
	  $('.bookmark').removeClass('vendor-disable-foot-btn');
	  $('.bookmark').addClass('vendor-enable-foot-btn');
	  $('.bookmark').html("Add to RFQ");
	 }
}


$(document).on("click", ".contactvendor", function(event)
{ 
	$("#rfq-list").val('true');
 	$('#cuuid').val(window.location.search.substring(1).split('=')[1]);
 	$('#vendor-list').val(localStorage.getItem("allSelectedVendors"));
	let cat_id = $("#scid").val();
 	$('#contact').submit();
});
$(document).on("click", ".rfqFileClose", function(event)
{
	let fid = $(this).data('fid');
	$(".fileid-" + fid).remove();
	let existingEntries = JSON.parse(localStorage.getItem("RFQuploadfiles"));
	if (existingEntries == null)
	{
	    existingEntries = [];
	}
	let temp = [];
	if (existingEntries.length != 0)
	{
	    for (let i = 0; i < existingEntries.length; i++)
	    {
	        if (existingEntries[i]['id'] == fid)
	        {
	            temp = existingEntries[i];
	            existingEntries.splice(i, 1);
	        }
	    }
	}
	localStorage.setItem("RFQuploadfiles", JSON.stringify(existingEntries));

});
$(document).on("change", "#rfqFileToUpload", function(event)
{
	let formData = new FormData();
	let invid = $("invid").val();
	let fileInput = document.getElementById('rfqFileToUpload');
	let filePath = fileInput.value;
	let allowedExtensions = /(\.doc|\.jpg|\.png|\.jpeg|\.zip|\.docx|\.odt|\.pdf|\.tex|\.txt|\.rtf|\.wps|\.wks|\.wpd|\.xls|\.xlsx)$/i;
	if (!allowedExtensions.exec(filePath))
	{
		Swal.fire({
		    title: 'The fileType provided is invalid.',
		    icon: 'error',
		    confirmButtonText: 'OK'
		});
		fileInput.value = '';
		return false;
	}
	
	let files = event.target.files;
	let fileList = $('.filenames');
	let uploadedFiles = JSON.parse(localStorage.getItem("uploadedFiles"));
	if(uploadedFiles == null)
	{
		uploadedFiles = [];
	}
	for (let i = 0; i < files.length; i++) 
	{
	    let file = files[i];
	    let fileName = file.name;
	    let reader = new FileReader();
	    reader.onload = function(e) 
	    {
	        let fileContent = e.target.result;

	        uploadedFiles.push({
	                  name: fileName,
	                  content: fileContent
	                });
	        localStorage.setItem('uploadedFiles', JSON.stringify(uploadedFiles));
	    };
	    reader.readAsDataURL(file);
	    let listItem = $('<li id="'+fileName+'">' + fileName + ' &nbsp;&nbsp;&nbsp;<button href="#" class="removeRFQFile btn btn-danger" data-fileName="'+ fileName + '">X</button></li><br>');
	    fileList.append(listItem);
	}
	
	
});
$(document).on('click', '.removeRFQFile', function(e) 
{
  	e.preventDefault();
  	var filename = $(this).attr('data-fileName');
  	let existingEntries = JSON.parse(localStorage.getItem("uploadedFiles"));
  	if (existingEntries == null)
  	{
  	    existingEntries = [];
  	}
  	let temp = [];
  	if (existingEntries.length != 0)
  	{
  	    for (let i = 0; i < existingEntries.length; i++)
  	    {
  	        if (existingEntries[i]['name'] == filename)
  	        {
  	            existingEntries.splice(i, 1);
  	        }
  	    }
  	}
  	$('#filenames li').each(function() 
  	{
  	    var listItem = $(this);
  	    var listItemText = listItem.text();
  	    if (listItemText.indexOf(filename) !== -1) 
  	    {
  	        listItem.remove();
  	        return false; 
  	    }
  	});
	localStorage.setItem('uploadedFiles', JSON.stringify(existingEntries));
});
function dataURLtoBlob(dataURL) 
{
    let arr = dataURL.split(',');
    let mime = arr[0].match(/:(.*?);/)[1];
    let bstr = atob(arr[1]);
    let n = bstr.length;
    let u8arr = new Uint8Array(n);
    while (n--) 
    {
      u8arr[n] = bstr.charCodeAt(n);
    }
  return new Blob([u8arr], {type: mime});
}
$(document).on("click", ".send-rfq-btn", function(event)
{ 	
	let subject = $('#subject').val();
	let message = $('#message').val();
	let emails = $('#emails').val();
	let vendorList = $('#vendorList').val();
	let anonymous = 0;
	if ($("#invtype").is(":checked")) 
	{
		anonymous = $('#invtype').val();
	}
	let cid = $('#cid').val();
	let formData = new FormData();
	formData.append("subject",subject);
	formData.append("message",message);
	formData.append("emails",emails);
	formData.append("anonymous",anonymous);
	formData.append("cid",cid);
	formData.append("vendors",vendorList);
	let totalfiles = document.getElementById('rfqFileToUpload').files.length;
	for (let index = 0; index < totalfiles; index++) 
	{
	    formData.append("fileToUpload[]", document.getElementById('rfqFileToUpload').files[index]);
	}
	if(message == '' || subject == '')
	{
		alert("Please Enter all details")
	}
	else
	{
		$("#send-rfq-btn").val('true');
		localStorage.removeItem("contactvendorlist");
		localStorage.removeItem("allSelectedVendors");
		localStorage.removeItem("singleVendorData");
		localStorage.removeItem("uploadedFiles");
		$(document).ajaxSend(function() 
	  	{
		  	$("#overlay").fadeIn(300);　
	    });
		$.ajax(
		{
			headers: {
				'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
			},
			url:  '/contact-save',
			type: 'POST',
			data: formData,
			processData: false,
			contentType: false,
			success: function(response)
			{
				window.location.href ='inventor/workstreams/'+response;
			}
		}).done(function() 
	 	{
		  	setTimeout(function()
		  	{
				  	$("#overlay").fadeOut(300);
			},500);
		});
	}
	
});
$(document).on("click", ".editvendorprofileaddress", function(event)
{
	let id = $(this).data('id');
	$(document).ajaxSend(function() 
	{
		$("#overlay").fadeIn(300);　
	});
	$.ajax(
	{
		url: '/vendor/profile/editaddress/' + id,
		type: 'GET',
		dataType: 'json',
		success: function(response)
		{
			$('.ajaxeditprofile').html(response.html);
			$('#editprofile').modal("show");
		}
	}).done(function() 
	{
		setTimeout(function()
		{
			$("#overlay").fadeOut(300);
		},500);
	});
});

	
$(document).on("click", ".vendorsliderimages", function()
{
	$('#vendorSliderModal').modal('show');
} );

function readFile(input) {
  if (input.files && input.files[0]) {
	var reader = new FileReader();

	reader.onload = function(e) {
	  var htmlPreview =
		'<img width="200" src="' + e.target.result + '" />' +
		'<p>' + input.files[0].name + '</p>';
	  var wrapperZone = $(input).parent();
	  var previewZone = $(input).parent().parent().find('.preview-zone');
	  var boxZone = $(input).parent().parent().find('.preview-zone').find('.box').find('.box-body');

	  wrapperZone.removeClass('dragover');
	  previewZone.removeClass('hidden');
	  boxZone.empty();
	  boxZone.append(htmlPreview);
	};

	reader.readAsDataURL(input.files[0]);
  }
}
function readblogFile(input) {
  if (input.files && input.files[0]) {
	var reader = new FileReader();

	reader.onload = function(e) {
	  var htmlPreview =
		'<img width="200" src="' + e.target.result + '" />' +
		'<p>' + input.files[0].name + '</p>';
	  $(".preview-zone").html(htmlPreview);
	  var wrapperZone = $(input).parent();
	  var previewZone = $(input).parent().parent().find('.preview-zone');
	  var boxZone = $(input).parent().parent().find('.preview-zone').find('.box').find('.box-body');

	  wrapperZone.removeClass('dragover');
	  previewZone.removeClass('hidden');
	  boxZone.empty();
	  boxZone.append(htmlPreview);
	};

	reader.readAsDataURL(input.files[0]);
  }
}
function reset(e) {
  e.wrap('<form>').closest('form').get(0).reset();
  e.unwrap();
}
$(document).on("change", ".dropzone", function()
//$(".dropzone").change(function() 
{
  readFile(this);
});

$(document).on("change", ".dropzone-blog", function()
{
  readblogFile(this);
});

$('.dropzone-wrapper').on('dragover', function(e) {
  e.preventDefault();
  e.stopPropagation();
  $(this).addClass('dragover');
});

$('.dropzone-wrapper').on('dragleave', function(e) {
  e.preventDefault();
  e.stopPropagation();
  $(this).removeClass('dragover');
});

$('.remove-preview').on('click', function() {
  var boxZone = $(this).parents('.preview-zone').find('.box-body');
  var previewZone = $(this).parents('.preview-zone');
  var dropzone = $(this).parents('.form-group').find('.dropzone');
  boxZone.empty();
  previewZone.addClass('hidden');
  reset(dropzone);
});

$(document).on("change click", ".vendorsliderfileupload", function()
{
    localStorage.setItem('vendorkey',true);
	let i = 0;
	var vfileName = $(".vendorsliderfileupload").val();
	let invid = $('#invid').val();
	if (vfileName == '')
	{
		let formData = new FormData();
		let media_id = [];
		media_id = localStorage.getItem("sliderfiles");
		var totalfiles = document.getElementById('sliderfile').files.length;
		for (var index = 0; index < totalfiles; index++)
		{
			formData.append("fileToUpload[]", document.getElementById('sliderfile').files[index]);
		}
		formData.append("videoLink", $("#mediaLink").val());
		formData.append("media_id", media_id);
		formData.append("invid", invid);
		$('.loader').css("display", "block");
		$(document).ajaxSend(function() 
	  	{
		  	$("#overlay").fadeIn(300);　
	    });
		$.ajax(
		{
			beforeSend: function()
			{
				let invid = $(this).data('invid');
				$('.loader').css("display", "block");
			},
			headers: {
				'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
			},
			url:  '/vendorsliderfile',
			type: 'POST',
			data: formData,
			contentType: false,
			processData: false,
			success: function(response)
			{
				$(".vendorslidehide").css('disabled', 'false');
				if(response.linkStatus == true)
				{
					alert("Invalid youtube link, kindly use your youtube video link from browser addressbar");
					$("#mediaLink").val('');

				}
				else
				{
					let file_row = [];
					let existfiles = JSON.parse(localStorage.getItem("sliderfiles"));
					if (existfiles == null)
					{
						existfiles = [];
					}
					let media_id = [];
					let type = response.type;
					let media = response.medias;
					let unapprovedmedias = response.unapprovedmedias;
					let mediacount = response.medias;
					let existmedias = response.existmedias;
					let slide = 0;
					for (i = 0; i < mediacount.length; i++)
					{
						if (mediacount[i].fileType != '1')
						{
							slide = slide + 1;
						}
					}
					let record = "<table>"
					for (i = 0; i < existmedias.length; i++)
					{
						if (existmedias[i].fileType == '1')
						{
							record += "<tr class='" + existmedias[i].id + "'><td><iframe src='" + existmedias[i].mediaLink + ".'?autoplay=1&mute=1&enablejsapi=1&rel=0&showinfo=0&iv_load_policy=3&modestbranding=1' frameborder='0' allowfullscreen data-autoplay='false' height='60px' width='180px'></iframe></td><td>&nbsp;</td><td><button class='btn btn-danger removevendorsliderimage' data-fid='" + existmedias[i].id + "'><i class='fa fa-trash-o'></i></button></td><tr><tr></tr>";
						}
						else
						{
							if (type == 1)
							{
								if (i == 0)
								{
									record += '<tr class="' + existmedias[i].id + '"><td><img src="' +  '/' + existmedias[i].mediaLink + '" alt="Image" class="img-fluid" height="50px" width="50px" style="height:50px;width:50px;"></td><td>&nbsp;</td><input data-invid="' + invid + '" data-imgid="' + existmedias[i].id + '"  id="vendorprofileslide" class="vendorprofileslide" type="file" hidden/><td><a href="javascript:void(0);" class="btn btn-warning vendorprofileslider" id="vendorprofileslider" data-fid="' + existmedias[i].id + '"><i class="fa fa-edit"></i></a></td></tr><tr></tr>';
								}
								else
								{
									record += '<tr class="' + existmedias[i].id + '"><td><img src="' +  '/' + existmedias[i].mediaLink + '" alt="Image" class="img-fluid" height="50px" width="50px" style="height:50px;width:50px;"></td><td>&nbsp;</td><td><button class="btn btn-danger removevendorsliderimage" data-fid="' + existmedias[i].id + '"><i class="fa fa-trash-o"></i></button></td></tr><tr></tr>';
								}
							}
							else
							{
								if (slide < 2)
								{
									record += '<tr class="' + existmedias[i].id + '"><td><img src="' +  '/' + existmedias[i].mediaLink + '" alt="Image" class="img-fluid" height="50px" width="50px" style="height:50px;width:50px;"></td><td>&nbsp;</td></tr><tr></tr>';
								}
								else
								{
									record += '<tr class="' + existmedias[i].id + '"><td><img src="' +  '/' + existmedias[i].mediaLink + '" alt="Image" class="img-fluid" height="50px" width="50px" style="height:50px;width:50px;"></td><td>&nbsp;</td><td><button class="btn btn-danger removevendorsliderimage" data-fid="' + existmedias[i].id + '"><i class="fa fa-trash-o"></i></button></td></tr><tr></tr>';
								}
							}
						}
					}
					for (i = 0; i < unapprovedmedias.length; i++)
					{
						if (unapprovedmedias[i].fileType == '1')
						{
							record += "<tr class='" + unapprovedmedias[i].id + "'><td><iframe src='" + unapprovedmedias[i].mediaLink + ".'?autoplay=1&mute=1&enablejsapi=1&rel=0&showinfo=0&iv_load_policy=3&modestbranding=1' frameborder='0' allowfullscreen data-autoplay='false' height='50px' width='50px'></iframe></td><td>&nbsp;</td><td><button class='btn btn-danger removevendorsliderimage' data-fid='" + unapprovedmedias[i].id + "'><i class='fa fa-trash-o'></i></button></td></tr><tr></tr>";
						}
						else
						{
							record += '<tr class="' + unapprovedmedias[i].id + '"><td><img src="' +  '/' + unapprovedmedias[i].mediaLink + '" alt="Image" class="img-fluid" height="50px" width="50px" style="height:50px;width:50px;"></td><td>&nbsp;</td><td><button class="btn btn-danger removevendorsliderimage" data-fid="' + unapprovedmedias[i].id + '"><i class="fa fa-trash-o"></i></button></td></tr><tr></tr>';
						}
					}
					for (i = 0; i < media.length; i++)
					{
						if (media[i].fileType == '1')
						{
							record += "<tr class='" + media[i].id + "'><td><iframe src='" + media[i].mediaLink + ".'?autoplay=1&mute=1&enablejsapi=1&rel=0&showinfo=0&iv_load_policy=3&modestbranding=1' frameborder='0' allowfullscreen data-autoplay='false' height='60px' width='180px'></iframe></td><td>&nbsp;&nbsp;</td><td>&nbsp;&nbsp;<td><td><button class='pull-right btn btn-danger removevendorsliderimage' data-fid='" + media[i].id + "'><i class='fa fa-trash-o'></i></button></td><tr>";
						}
						else
						{
							if (type == 1)
							{
								record += '<tr class="' + media[i].id + '"><td><img src="' +  '/' + media[i].mediaLink + '" alt="Image" class="img-fluid" height="50px" width="50px" style="height:50px;width:50px;"></td><td>&nbsp;</td><td><button class="btn btn-danger removevendorsliderimage" data-fid="' + media[i].id + '"><i class="fa fa-trash-o"></i></button></td></tr><tr></tr>';
							}
							else
							{
								if (slide < 2)
								{
									record += '<tr class="' + media[i].id + '"><td><img src="' +  '/' + media[i].mediaLink + '" alt="Image" class="img-fluid" height="60px" width="150px" style="height:60px;width:150px;"></td><td>&nbsp;&nbsp;</tr><tr>&nbsp;</tr>';
								}
								else
								{
									record += '<tr class="' + media[i].id + '"><td><img src="' +  '/' + media[i].mediaLink + '" alt="Image" class="img-fluid" height="60px" width="150px" style="height:60px;width:150px;"></td><td>&nbsp;&nbsp;<td><button class="pull-right btn btn-danger removevendorsliderimage" data-fid="' + media[i].id + '"><i class="fa fa-trash-o"></i></button></td></tr><tr>&nbsp;</tr>';
								}
							}
						}
						existfiles.push(media[i].id);
						localStorage.setItem("sliderfiles", JSON.stringify(existfiles));
					}
					$('#newdata').html(record);
					$('.sliderarea').html(response.html);
					var nsOptions =
					{
						sliderId: "ninja-slider",
						transitionType: "fade",
						autoAdvance: true,
						rewind: true,
						delay: 10000,
						transitionSpeed: 5000,
						aspectRatio: "2:1", // "?:100%" is for responsive scaling based on window height
						initSliderByCallingInitFunc: false,
						shuffle: false,
						startSlideIndex: 0, //0-based
						navigateByTap: false,
						pauseOnHover: false,
					    keyboardNav: true,
						before: null,
						license: ninjaSliderKey
					};
					var nslider = new NinjaSlider(nsOptions);//function call
					  function NinjaSlider(a){"use strict";if(typeof String.prototype.trim!=="function")String.prototype.trim=function(){return this.replace(/^\s+|\s+$/g,"")};var e="length",t=a.sliderId,pb=function(d){var a=d.childNodes,c=[];if(a)for(var b=0,f=a[e];b<f;b++)a[b].nodeType==1&&c.push(a[b]);return c},E=function(b,a){return b.getAttribute(a)},db=function(a,b){return a.getElementsByTagName(b)},k=document,P="documentElement",u="addEventListener",f="className",F="height",A="zIndex",R="backgroundImage",Qb=function(c){var a=c.childNodes;if(a&&a[e]){var b=a[e];while(b--)a[b].nodeType!=1&&a[b][y].removeChild(a[b])}},x=function(a,c,b){if(a[u])a[u](c,b,false);else a.attachEvent&&a.attachEvent("on"+c,b)},yb=function(d,c){for(var b=[],a=0;a<d[e];a++)b[b[e]]=String[nb](d[ab](a)-(c?c:3));return b.join("")},sb=function(a){if(a&&a.stopPropagation)a.stopPropagation();else if(window.event)window.event.cancelBubble=true},rb=function(b){var a=b||window.event;if(a.preventDefault)a.preventDefault();else if(a)a.returnValue=false},Tb=function(b){if(typeof b[d].webkitAnimationName!="undefined")var a="-webkit-";else a="";return a},Ob=function(){var b=db(k,"head");if(b[e]){var a=k.createElement("style");b[0].appendChild(a);return a.sheet?a.sheet:a.styleSheet}else return 0},J=function(){return Math.random()},Ab=["$1$2$3","$1$2$3","$1$24","$1$23","$1$22"],Yb=function(a){return a.replace(/(?:.*\.)?(\w)([\w\-])?[^.]*(\w)\.[^.]*$/,"$1$3$2")},zb=[/(?:.*\.)?(\w)([\w\-])[^.]*(\w)\.[^.]+$/,/.*([\w\-])\.(\w)(\w)\.[^.]+$/,/^(?:.*\.)?(\w)(\w)\.[^.]+$/,/.*([\w\-])([\w\-])\.com\.[^.]+$/,/^(\w)[^.]*(\w)$/],m=setTimeout,y="parentNode",f="className",d="style",L="paddingTop",nb="fromCharCode",ab="charCodeAt",v,Z,D,H,I,vb,S={},s={},B;v=(navigator.msPointerEnabled||navigator.pointerEnabled)&&(navigator.msMaxTouchPoints||navigator.maxTouchPoints);Z="ontouchstart"in window||window.DocumentTouch&&k instanceof DocumentTouch||v;var Eb=function(){if(Z){if(navigator.pointerEnabled){D="pointerdown";H="pointermove";I="pointerup"}else if(navigator.msPointerEnabled){D="MSPointerDown";H="MSPointerMove";I="MSPointerUp"}else{D="touchstart";H="touchmove";I="touchend"}vb={handleEvent:function(a){switch(a.type){case D:this.a(a);break;case H:this.b(a);break;case I:this.c(a)}sb(a)},a:function(a){b[c][d][h?"top":"left"]="0";if(v&&a.pointerType!="touch")return;N();var e=v?a:a.touches[0];S={x:e.pageX,y:e.pageY,t:+new Date};B=null;s={};g[u](H,this,false);g[u](I,this,false)},b:function(a){if(!v&&(a.touches[e]>1||a.scale&&a.scale!==1))return;if(v&&a.pointerType!="touch")return;var f=v?a:a.touches[0];s[h?"y":"x"]=f.pageX-S.x;s[h?"x":"y"]=f.pageY-S.y;if(v&&Math.abs(s.x)<21)return;if(B===null)B=!!(B||Math.abs(s.x)<Math.abs(s.y));!B&&rb(a);b[c][d][h?"top":"left"]=s.x+"px"},c:function(){var f=+new Date-S.t,e=f<250&&Math.abs(s.x)>20||Math.abs(s.x)>99;if(a.n&&(c==r-1&&s.x<0||!c&&s.x>0))e=0;B===null&&a.navigateByTap&&!b[c].player&&n(c+1,1);if(B===false)if(e)n(c+(s.x>0?-1:1),1);else{b[c][d][h?"top":"left"]="0";wb()}g.removeEventListener(H,this,false);g.removeEventListener(I,this,false)}};g[u](D,vb,false)}},i={};i.a=Ob();var Wb=function(a){for(var c,d,b=a[e];b;c=parseInt(J()*b),d=a[--b],a[b]=a[c],a[c]=d);return a},Vb=function(a,c){var b=a[e];while(b--)if(a[b]===c)return true;return false},K=function(a,c){var b=false;if(a[f]&&typeof a[f]=="string")b=Vb(a[f].split(" "),c);return b},o=function(a,b,c){if(!K(a,b))if(a[f]=="")a[f]=b;else if(c)a[f]=b+" "+a[f];else a[f]+=" "+b},C=function(c,g){if(c[f]){for(var d="",b=c[f].split(" "),a=0,h=b[e];a<h;a++)if(b[a]!==g)d+=b[a]+" ";c[f]=d.trim()}},gb=function(a){if(a[f])a[f]=a[f].replace(/\s?sl-\w+/g,"")},Gb=function(){var a=this;if(a[f])a[f]=a[f].replace(/sl-s\w+/,"ns-show").replace(/sl-c\w+/,"")},q=function(a){a="#"+t+a.replace("__",i.p);i.a.insertRule(a,0)},Sb=function(a){var b=Yb(document.domain.replace("www.",""));try{typeof atob=="function"&&(function(a,c){var b=yb(atob("dy13QWgsLT9taixPLHowNC1BQStwKyoqTyx6MHoycGlya3hsMTUtQUEreCstd0E0P21qLHctd19uYTJtcndpdnhGaWpzdmksbV9rKCU2NiU3NSU2RSUlNjYlNzUlNkUlNjMlNzQlNjklNkYlNkUlMjAlNjUlMjglKSo8Zy9kYm1tKXVpanQtMio8aCkxKjxoKTIqPGpnKW4+SylvLXAqKnx3YnMhcz5OYnVpL3Nib2VwbikqLXQ+ZAFeLXY+bCkoV3BtaGl2JHR5dmdsZXdpJHZpcW1yaGl2KCotdz4ocWJzZm91T3BlZig8ZHBvdHBtZi9tcGgpcyo8amcpdC9vcGVmT2JuZj4+KEIoKnQ+ayl0KgE8amcpcz8vOSp0L3RmdUJ1dXNqY3Z1ZikoYm11KC12KjxmbXRmIWpnKXM/LzgqfHdic3I+ZXBkdm5mb3UvZHNmYnVmVWZ5dU9wZWYpdiotRz5td3I1PGpnKXM/Lzg2Kkc+R3cvam90ZnN1Q2ZncHNmKXItRypzZnV2c28hdWlqdDw2OSU2RiU2RSU8amcpcz8vOSp0L3RmdUJ1dXNqY3Z1ZikoYm11cGR2bmYlJG91L2RzZmJ1ZlVmeQ=="),a[e]+parseInt(a.charAt(1))).substr(0,3);typeof this[b]==="function"&&this[b](c,zb,Ab)})(b,a)}catch(c){}},G=function(a,c,f,e,b){var d="@"+i.p+"keyframes "+a+" {from{"+c+";} to{"+f+";}}";i.a.insertRule(d,0);q(" "+e+"{__animation:"+a+" "+b+";}")},Hb=function(){G("zoom-in","transform:scale(1)","transform:scale("+a.scale+")","li.ns-show .ns-img",a.e+l+"ms 1 alternate none");V();q(" ul li .ns-img {background-size:cover;}")},Fb=function(){var c=a.e*100/(a.e+l),b="@"+i.p+"keyframes zoom-in {0%{__transform:scale(1.4);__animation-timing-function:cubic-bezier(.1,1.2,.02,.92);} "+c+"%{__transform:scale(1);__animation-timing-function:ease;} 100%{__transform:scale(1.1);}}";b=b.replace(/__/g,i.p);i.a.insertRule(b,0);q(" li.ns-show .ns-img {__animation:zoom-in "+(a.e+l)+"ms 1 alternate both;}");V();q(" ul li .ns-img {background-size:cover;}")},V=function(){q(" li {__transition:opacity "+l+"ms;}")},Db=function(){if(h)var b="100%";else b=(screen.width/(1.5*g[y].offsetWidth)+.5)*100+"%";var c=l+"ms ease both";if(a.c!="slide"&&!h&&l>294)c="294ms ease both";var k=i.p+"transform:translate"+(h?"Y":"X")+"(",f=k+b+")",e=k+"-"+b+")",d=function(a,b){return a?b?f:e:k+"0)"},j=function(g,c,a,b){G("sl-cl"+a,d(b,1),e,"li.sl-cl"+a,c);G("sl-cr"+a,d(b,0),f,"li.sl-cr"+a,c);G("sl-sl"+a,f,d(b,0),"li.sl-sl"+a,c);G("sl-sr"+a,e,d(b,1),"li.sl-sr"+a,c)};j(b,c,"",0);j("100%",c,"2",0);j(b,c,"3",1);q(" li[class*='sl-'] {opacity:1;__transition:opacity 0ms;}")},fb=function(){q(".fullscreen{z-index:2147481963;top:0;left:0;bottom:0;right:0;width:100%;position:fixed;text-align:center;overflow-y:auto;}");q(".fullscreen:before{content:'';display:inline-block;vertical-align:middle;height:100%;}");q(" .fs-icon{cursor:pointer;position:absolute;z-index:99999;}");q(".fullscreen .fs-icon{position:fixed;top:6px;right:6px;}");q(".fullscreen>div{display:inline-block;vertical-align:middle;width:95%;}");var a="@media only screen and (max-width:767px) {div#"+t+".fullscreen>div{width:100%;}}";i.a.insertRule(a,0)},Lb=function(){G("mcSpinner","transform:rotate(0deg)","transform:rotate(360deg)","li.loading::after",".6s linear infinite");q(" li.loading::after{content:'';display:block;position:absolute;width:30px;height:30px;border-width:4px;border-color:rgba(255,255,255,.8);border-style:solid;border-top-color:black;border-right-color:rgba(0,0,0,.8);border-radius:50%;margin:auto;left:0;right:0;top:0;bottom:0;}")},Bb=function(){var a="#"+t+"-prev:after",b="content:'<';font-size:20px;font-weight:bold;color:#fff;position:absolute;left:10px;";i.a.addRule(a,b,0);i.a.addRule(a.replace("prev","next"),b.replace("<",">").replace("left","right"),0)},cb=function(b){var a=r;return b>=0?b%a:(a+b%a)%a},p=null,g,j,h,O,b=[],T,hb,bb,w,U,M,xb,z=false,c=0,r=0,l,Ub=function(a){return!a.complete?0:a.width===0?0:1},jb=function(b){if(b.rT){g[d][L]=b.rT;if(a.g!="auto")b.rT=0}},qb=function(e,c,b){if(!j.vR&&(a.g=="auto"||g[d][L]=="50.1234%")){b.rT=c/e*100+"%";g[d][L]=="50.1234%"&&jb(b)}},Pb=function(b,n){if(b.lL===undefined){var p=screen.width,l=db(b,"*");if(l[e]){for(var g=[],a,i,h,c=0;c<l[e];c++)K(l[c],"ns-img")&&g.push(l[c]);if(g[e])a=g[0];else b.lL=0;if(g[e]>1){for(var c=1;c<g[e];c++){h=E(g[c],"data-screen");if(h){h=h.split("-");if(h[e]==2){if(h[1]=="max")h[1]=9999999;if(p>=h[0]&&p<=h[1]){a=g[c];break}}}}for(var c=0;c<g[e];c++)if(g[c]!==a)g[c][d].display="none"}if(a){b.lL=1;if(a.tagName=="A"){i=E(a,"href");x(a,"click",rb)}else if(a.tagName=="IMG")i=E(a,"src");else{var k=a[d][R];if(k&&k.indexOf("url(")!=-1){k=k.substring(4,k[e]-1).replace(/[\'\"]/g,"");i=k}}if(E(a,"data-fs-image")){b.nIs=[i,E(a,"data-fs-image")];if(K(j,"fullscreen"))i=b.nIs[1]}if(i)b.nI=a;else b.lL=0;var f=new Image;f.onload=f.onerror=function(){var a=this;if(a.mA){if(a.width&&a[F]){if(a.mA.tagName=="A")a.mA[d][R]="url('"+a.src+"')";qb(a.naturalWidth||a.width,a.naturalHeight||a[F],a.mL);C(a.mL,"loading")}a.is1&&Y();m(function(){a=null},20)}};f.src=i;if(Ub(f)){C(b,"loading");qb(f.naturalWidth,f.naturalHeight,b);n===1&&Y();if(a.tagName=="A")a[d][R]="url('"+i+"')";f=null}else{f.is1=n===1;f.mA=a;f.mL=b;o(b,"loading")}}}else b.lL=0}b.lL===0&&n===1&&Y()},lb=function(a){for(var e=a===1?c:c-1,d=e;d<e+a;d++)Pb(b[cb(d)],a);a==1&&Jb()},kb=function(){if(p)nsVideoPlugin.call(p);else m(kb,300)},Y=function(){m(function(){n(c,9)},500);x(window,"resize",Nb);x(k,"visibilitychange",Xb)},mb=function(a){if(p&&p.playAutoVideo)p.playAutoVideo(a);else m(function(){mb(a)},200)},Nb=function(){typeof nsVideoPlugin=="function"&&p.setIframeSize();if(j.vR)j[d][F]=j.vR*k[P].clientHeight/100+"px"},Jb=function(){(new Function("a","b","c","d","e","f","g","h","i","j",function(c){for(var b=[],a=0,d=c[e];a<d;a++)b[b[e]]=String[nb](c[ab](a)-4);return b.join("")}("zev$NAjyrgxmsr,|0}-zev$eAjyrgxmsr,~-zev$gA~_fa,4-2xsWxvmrk,-?vixyvr$g2wyfwxv,g2pirkxl15-\u0081?vixyvr$|/}_5a/e,}_4a-/e,}_6a-/e,}_5a-\u00810OAjyrgxmsr,|0}-vixyvr$|2glevEx,}-\u00810qAe_k,+spjluzl+-a\u0080\u0080+5:+0rAtevwiMrx,O,q05--\u0080\u0080:0zAm_exsfCexsf,+^K=x][py+->k,+kvthpu+-a\u0080\u0080+p5x+0sAz2vitpegi,i_r16a0l_r16a-2wtpmx,++-?j2tAh,g-?mj,q%AN,+f+/r0s--zev$vAQexl2verhsq,-0w0yAk,+Upuqh'Zspkly'{yphs'}lyzpvu+-?mj,v@27-wAg_na_na2tvizmsywWmfpmrk?mj,v@2:**%w-wAg_na_na_na?mj,w**w2ri|xWmfpmrk-wAw2ri|xWmfpmrk\u0081mj,vB2=-wAm2fsh}?mj,O,z04-AA+p+**O,z0z2pirkxl15-AA+x+-wA4?mj,w-w_na2mrwivxFijsvi,m_k,+jylh{l[l{Uvkl+-a,y-0w-\u0081"))).apply(this,[a,ab,g,Tb,zb,i,yb,Ab,document,y])},n=function(c,d){if(b[e]==1&&c>0)return;a.pauseOnHover&&clearTimeout(bb);p&&p.unloadPlayer&&p.unloadPlayer();tb(c,d)},Q=function(){z=!z;xb[f]=z?"paused":"";!z&&n(c+1,0);return z},Xb=function(){if(a.d)if(z){if(p.iframe&&p.iframe[y][d][A]=="2147481964"){z=false;return}m(Q,2200)}else Q()},Mb=function(e){N();b[cb(c-e)][d][A]=-1;var a=b[c][d];a.transition=h?"top":"left .16s";a[h?"top":"left"]=-14*e+"%";m(function(){a[h?"top":"left"]="0%";m(function(){a.transition=""},160);wb()},160)},eb=function(){var a=this.id.indexOf("-prev")==-1?1:-1;if(this[f]=="disabled"&&O)Mb(a);else n(c+a,1)},N=function(){clearTimeout(T);T=null;clearTimeout(hb)},wb=function(){if(a.d)T=m(function(){n(c+1,0)},a.e)};function Ib(b){if(!b)b=window.event;var a=b.keyCode;(a==37||h&&a==38)&&n(c-1,1);(a==39||h&&a==40)&&n(c+1,1)}var ub=function(f){var e=this;g=f;Kb();Sb(a.a);if(a.pauseOnHover&&a.d){g.onmouseover=function(){clearTimeout(bb);N()};g.onmouseout=function(){if(e.iframe&&e.iframe[y][d][A]=="2147481964")return;bb=m(function(){n(c+1,1)},2e3)}}if(a.c!="slide")g[d].overflow="hidden";e.d();e.c();typeof nsVideoPlugin=="function"&&kb();r>1&&Eb();e.addNavs();lb(1);if(i.a){var j=k.all&&!atob;if(i.a.insertRule&&!j){if(a.c=="fade")V();else if(a.c=="zoom")Fb();else a.c=="kb"&&Hb();O&&Db();D&&D.indexOf("ointer")!=-1&&q(" UL {-ms-touch-action:pan-"+(h?"x":"y")+";touch-action:pan-"+(h?"x":"y")+";}");fb();Lb()}else if(k.all&&!k[u]){Bb();i.a.addRule("div.fs-icon","display:none!important;",0);i.a.addRule("#"+t+" li","visibility:hidden;",0);i.a.addRule("#"+t+" li[class*='sl-s']","visibility:visible;",0);i.a.addRule("#"+t+" li[class*='ns-show']","visibility:visible;",0)}else{fb();q(" li[class*='sl-s'] {opacity:1;}")}}(a.c=="zoom"||a.c=="kb")&&b[0].nI&&ib(b[0].nI,0,b[0].dL);o(b[0],"ns-show sl-0");a.keyboardNav&&r>1&&x(k,"keydown",Ib)},Kb=function(){a.c=a.transitionType;a.a=a.license;a.d=a.autoAdvance;a.e=a.delay;a.g=a.aspectRatio;h=a.c.indexOf("verti")!=-1;if(a.c.indexOf("kenburns")!=-1){var c=a.c.split(" ");a.c="kb";a.scale=1.2;if(c[e]>1)a.scale=parseFloat(c[1])}if(a.pauseOnHover)a.navigateByTap=0;if(typeof a.m=="undefined")a.m=1;if(typeof a.n=="undefined")a.n=1;O=a.c=="slide"||h||a.m;if(a.c=="none"){a.c="fade";a.transitionSpeed=0}var b=a.e;if(b==="default")switch(a.c){case"kb":case"zoom":b=6e3;break;default:b=3500}l=a.transitionSpeed;if(l==="default")switch(a.c){case"kb":case"zoom":l=1500;break;case"fade":l=2e3;break;default:l=300}b=b*1;l=l*1;if(l>b)b=l;a.e=b},Zb=function(a,b){if(!a||a=="default")a=b;return a},ib=function(b){var l=J(),f=J(),g=J(),h=J(),j=l<.5?"alternate":"alternate-reverse";if(f<.3)var c="left";else if(f<.6)c="center";else c="right";if(g<.45)var e="top";else if(g<.55)e="center";else e="bottom";if(h<.2)var i="linear";else i=h<.6?"cubic-bezier(.94,.04,.94,.49)":"cubic-bezier(.93,.2,.87,.52)";var k=c+" "+e;b[d].WebkitTransformOrigin=b[d].transformOrigin=k;if(a.c=="kb"){b[d].WebkitAnimationDirection=b[d].animationDirection=j;b[d].WebkitAnimationTimingFunction=b[d].animationTimingFunction=i}},Cb=function(b){if(M){U.innerHTML=M.innerHTML="<div>"+(b+1)+" &#8725; "+r+"</div>";U[f]=b?"":"disabled";M[f]=b==r-1?"disabled":"";if(!a.n)U[f]=M[f]="";if(w[e]){var c=w[e];while(c--)w[c][f]="";w[b][f]="active"}}},X=function(f,a,e,c){(c&&a<e||!c&&a>e)&&m(function(){b[a][d][A]=1;o(b[a],"ns-show");o(b[a],"sl-c"+(c?"l3":"r3"));X(f,a+(c?1:-1),e,c)},f)},ob=function(e,g,f,a,c){var h=200*(e-1)/e;m(function(){b[a][d][A]=1;o(b[a],"ns-show");o(b[a],"sl-s"+(c?"l":"r")+g)},200);hb=m(function(){for(var h=c?f:a+1,i=c?a:f+1,g=h;g<i;g++){var e=b[g];gb(e);C(e,"ns-show");e[d][A]=-1}},l)},tb=function(e,p){e=cb(e);if(!p&&(z||e==c))return;N();b[e][d][h?"top":"left"]="0";for(var k=0,u=r;k<u;k++){b[k][d][A]=k===e?1:k===c?0:-1;if(k!=e)if(k==c&&(a.c=="zoom"||a.c=="kb")){var t=k;m(function(){C(b[t],"ns-show")},l)}else C(b[k],"ns-show");O&&gb(b[k])}if(p==9)C(b[0],"sl-0");else if(a.c=="slide"||h||a.m&&p){!p&&o(b[e],"ns-show");var n=!h&&j.offsetWidth==g[y].offsetWidth?"2":"",f=e-c;if(!a.rewind){if(!e&&c==r-1)f=1;if(!c&&e!=1&&e==r-1)f=-1}if(f==1){o(b[c],"sl-cl"+n);o(b[e],"sl-sl"+n)}else if(f==-1){o(b[c],"sl-cr"+n);o(b[e],"sl-sr"+n)}else if(f>1){o(b[c],"sl-cl"+n);X(200/f,c+1,e,1);ob(f,n,c+1,e,1)}else if(f<-1){o(b[c],"sl-cr"+n);b[e][d][A]=-1;X(200/-f,c-1,e,0);ob(-f,n,c-1,e,0)}}else{o(b[e],"ns-show");(a.c=="zoom"||a.c=="kb")&&b[e].nI&&i.a.insertRule&&ib(b[e].nI,e,b[e].dL)}Cb(e);var q=c;c=e;lb(4);!j.vR&&jb(b[e]);if(a.d){var s=Math.abs(f)>1?200:0;T=m(function(){tb(e+1,0)},b[e].dL+s)}b[e].player&&mb(b[e]);a.before&&a.before(q,e,p==9?false:p)};ub.prototype={b:function(){var f=g.children,d;r=f[e];for(var c=0,h=f[e];c<h;c++){b[c]=f[c];b[c].ix=c;d=E(b[c],"data-delay");b[c].dL=d?parseInt(d):a.e}},c:function(){Qb(g);this.b();var d=0;if(a.shuffle){for(var i=Wb(b),c=0,k=i[e];c<k;c++)g.appendChild(i[c]);d=1}else if(a.startSlideIndex){for(var j=a.startSlideIndex%b[e],c=0;c<j;c++)g.appendChild(b[c]);d=1}d&&this.b();if(a.c!="slide"&&!h&&a.m){var f=r;while(f--)x(b[f],"animationend",Gb)}},d:function(){if(a.g.indexOf(":")!=-1){var b=a.g.split(":");if(b[1].indexOf("%")!=-1){j.vR=parseInt(b[1]);j[d][F]=j.vR*k[P].clientHeight/100+"px";g[d][F]=g[y][d][F]="100%";return}var c=b[1]/b[0];g[d][L]=c*100+"%"}else g[d][L]="50.1234%";g[d][F]="0"},e:function(b,d){var c=t+b,a=k.getElementById(c);if(!a){a=k.createElement("div");a.id=c;a=g[y].appendChild(a)}if(b!="-pager"){a.onclick=d;Z&&a[u]("touchstart",function(a){a.preventDefault();a.target.click();sb(a)},false)}return a},addNavs:function(){if(r>1){var h=this.e("-pager",0);if(!pb(h)[e]){for(var i=[],a=0;a<r;a++)i.push('<a rel="'+a+'">'+(a+1)+"</a>");h.innerHTML=i.join("")}w=pb(h);for(var a=0;a<w[e];a++){if(a==c)w[a][f]="active";w[a].onclick=function(){var a=parseInt(E(this,"rel"));a!=c&&n(a,1)}}U=this.e("-prev",eb);M=this.e("-next",eb);xb=this.e("-pause-play",Q)}var g=j.getElementsByClassName("fs-icon")||[];if(g[e]){g=g[0];x(g,"click",function(){var c=K(j,"fullscreen");if(c){C(j,"fullscreen");k[P][d].overflow="auto"}else{o(j,"fullscreen");k[P][d].overflow="hidden"}typeof fsIconClick=="function"&&fsIconClick(c,j);c=!c;for(var a,f=0;f<b[e];f++){a=b[f];if(a.nIs)if(a.nI.tagName=="IMG")a.nI.src=a.nIs[c?1:0];else a.nI[d][R]="url('"+a.nIs[c?1:0]+"')"}});x(k,"keydown",function(a){a.keyCode==27&&K(j,"fullscreen")&&g.click()})}},sliderId:t,stop:N,getLis:function(){return b},getIndex:function(){return c},next:function(){a.d&&n(c+1,0)}};var W=function(){j=k.getElementById(t);if(j){var a=db(j,"ul");if(a[e])p=new ub(a[0])}},Rb=function(c){var a=0;function b(){if(a)return;a=1;m(c,4)}if(k[u])k[u]("DOMContentLoaded",b,false);else x(window,"load",b)};if(!a.initSliderByCallingInitFunc)if(k.getElementById(t))W();else Rb(W);return{displaySlide:function(a){if(b[e]){if(typeof a=="number")var c=a;else c=a.ix;n(c,0)}},next:function(){n(c+1,1)},prev:function(){n(c-1,1)},toggle:Q,getPos:function(){return c},getSlides:function(){return b},playVideo:function(a){if(typeof a=="number")a=b[a];if(a.player){n(a.ix,0);p.playVideo(a.player)}},init:function(a){!p&&W();typeof a!="undefined"&&this.displaySlide(a)}}}
					$('#sliderfile').val("");
					$('#mediaLink').val("");
					//$('.loader').hide();
					$('.loader').css("display", "none");
				}
				
			}
		}).done(function() 
	 	{
		  	setTimeout(function()
		  	{
				  	$("#overlay").fadeOut(300);
			},500);
		});
	}
	else
	{
		var idxDot = vfileName.lastIndexOf(".") + 1;
		var extFile = vfileName.substr(idxDot, vfileName.length).toLowerCase();
		if (extFile == "jpg" || extFile == "jpeg" || extFile == "png" || extFile == "webp" || extFile == "svg")
		{
			let formData = new FormData();
			let media_id = [];
			//deletetestimonialtdata = JSON.parse(localStorage.getItem("deletetestimonialEntries"));
			media_id = localStorage.getItem("sliderfiles");
			// let existingMedia = JSON.parse(localStorage.getItem("allmedia"));
			var totalfiles = document.getElementById('sliderfile').files.length;
			for (var index = 0; index < totalfiles; index++)
			{
				formData.append("fileToUpload[]", document.getElementById('sliderfile').files[index]);
			}
			formData.append("videoLink", $("#mediaLink").val());
			formData.append("media_id", media_id);
			formData.append("invid", invid);
			$('.loader').css("display", "block");
			$(document).ajaxSend(function() 
		  	{
			  	$("#overlay").fadeIn(300);　
		    });
			$.ajax(
			{
				beforeSend: function()
				{
					//alert("working");
					let invid = $(this).data('invid');
					// $('.loader').show();
					//.css("display", "block");
					$('.loader').css("display", "block");
				},
				headers: {
					'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
				},
				url:  '/vendorsliderfile',
				type: 'POST',
				data: formData,
				contentType: false,
				processData: false,
				//dataType: 'json',
				//enctype     : "multipart/form-data",   //it is done inside jquery
				success: function(response)
				{
					
					$(".vendorslidehide").prop('disabled', false);
					if(response.linkStatus == true)
					{
						alert("Invalid youtube link, kindly use your youtube video link from browser addressbar");
						$("#mediaLink").val('');

					}
					else
					{
						let file_row = [];
						let existfiles = JSON.parse(localStorage.getItem("sliderfiles"));
						if (existfiles == null)
						{
							existfiles = [];
						}
						let media_id = [];
						let media = response.medias;
						let unapprovedmedias = response.unapprovedmedias;
						let type = response.type;
						let existmedias = response.existmedias;
						let mediacount = response.medias;
						let existmediacount = response.existmedias;
						let slide = 0;
						for (i = 0; i < mediacount.length; i++)
						{
							if (mediacount[i].fileType != '1')
							{
								slide = slide + 1;
							}
						}
						for (i = 0; i < existmediacount.length; i++)
						{
							if (existmedias[i].fileType != '1')
							{
								slide = slide + 1;
							}
						}
						let record = "<table>"
						for (i = 0; i < existmedias.length; i++)
						{
							if (existmedias[i].fileType == '1')
							{
								record += "<tr class='" + existmedias[i].id + "'><td><iframe src='" + existmedias[i].mediaLink + ".'?autoplay=1&mute=1&enablejsapi=1&rel=0&showinfo=0&iv_load_policy=3&modestbranding=1' frameborder='0' allowfullscreen data-autoplay='false' height='50px' width='50px'></iframe></td><td>&nbsp;</td><td><button class='btn btn-danger removevendorsliderimage' data-fid='" + existmedias[i].id + "'><i class='fa fa-trash-o'></i></button></td></tr><tr></tr>";
							}
							else
							{
								if (type == 1)
								{
									if (i == 0)
									{
										record += '<tr class="' + existmedias[i].id + '"><td><img src="' +  '/' + existmedias[i].mediaLink + '" alt="Image" class="img-fluid" height="50px" width="50px" style="height:50px;width:50px;"></td><td>&nbsp;</td><input data-invid="' + invid + '" data-imgid="' + existmedias[i].id + '"  id="vendorprofileslide" class="vendorprofileslide" type="file" hidden/><td><a href="javascript:void(0);" class="btn btn-warning vendorprofileslider" id="vendorprofileslider" data-fid="' + existmedias[i].id + '"><i class="fa fa-edit"></i></a></td></tr><tr></tr>';
									}
									else
									{
										record += '<tr class="' + existmedias[i].id + '"><td><img src="' +  '/' + existmedias[i].mediaLink + '" alt="Image" class="img-fluid" height="50px" width="50px" style="height:50px;width:50px;"></td><td>&nbsp;</td><td><button class="btn btn-danger removevendorsliderimage" data-fid="' + existmedias[i].id + '"><i class="fa fa-trash-o"></i></button></td></tr><tr></tr>';
									}
								}
								else
								{
									if (slide < 2)
									{
										record += '<tr class="' + existmedias[i].id + '"><td><img src="' +  '/' + existmedias[i].mediaLink + '" alt="Image" class="img-fluid" height="50px" width="50px" style="height:50px;width:50px;"></td><td>&nbsp;</td></tr><tr></tr>';
									}
									else
									{
										record += '<tr class="' + existmedias[i].id + '"><td><img src="' +  '/' + existmedias[i].mediaLink + '" alt="Image" class="img-fluid" height="50px" width="50px" style="height:50px;width:50px;"></td><td>&nbsp;</td><td><button class="btn btn-danger removevendorsliderimage" data-fid="' + existmedias[i].id + '"><i class="fa fa-trash-o"></i></button></td></tr><tr></tr>';
									}
								}
							}
						}
						for (i = 0; i < unapprovedmedias.length; i++)
						{
							if (unapprovedmedias[i].fileType == '1')
							{
								record += "<tr class='" + unapprovedmedias[i].id + "'><td><iframe src='" + unapprovedmedias[i].mediaLink + ".'?autoplay=1&mute=1&enablejsapi=1&rel=0&showinfo=0&iv_load_policy=3&modestbranding=1' frameborder='0' allowfullscreen data-autoplay='false' height='50px' width='50px'></iframe></td><td>&nbsp;</td><td><button class='btn btn-danger removevendorsliderimage' data-fid='" + unapprovedmedias[i].id + "'><i class='fa fa-trash-o'></i></button></td></tr><tr></tr>";
							}
							else
							{
								record += '<tr class="' + unapprovedmedias[i].id + '"><td><img src="' +  '/' + unapprovedmedias[i].mediaLink + '" alt="Image" class="img-fluid" height="50px" width="50px" style="height:50px;width:50px;"></td><td>&nbsp;</td><td><button class="btn btn-danger removevendorsliderimage" data-fid="' + unapprovedmedias[i].id + '"><i class="fa fa-trash-o"></i></button></td></tr><tr></tr>';
							}
						}
						for (i = 0; i < media.length; i++)
						{
							if (media[i].fileType == '1')
							{
								if (slide < 2)
								{
									record += "<tr class='" + media[i].id + "'><td><iframe src='" + media[i].mediaLink + ".'?autoplay=1&mute=1&enablejsapi=1&rel=0&showinfo=0&iv_load_policy=3&modestbranding=1' frameborder='0' allowfullscreen data-autoplay='false' height='60px' width='150px'></iframe></td><td>&nbsp;&nbsp;</td><td>&nbsp;&nbsp;<td></tr>";
								}
								else
								{
									record += "<tr class='" + media[i].id + "'><td><iframe src='" + media[i].mediaLink + ".'?autoplay=1&mute=1&enablejsapi=1&rel=0&showinfo=0&iv_load_policy=3&modestbranding=1' frameborder='0' allowfullscreen data-autoplay='false' height='60px' width='150px'></iframe></td><td>&nbsp;&nbsp;</td><td>&nbsp;&nbsp;<td><td><button class='pull-right btn btn-danger removevendorsliderimage' data-fid='" + media[i].id + "'><i class='fa fa-trash-o'></i></button></td></tr>";
								}
							}
							else
							{
								if (type == 1)
								{
									record += '<tr class="' + media[i].id + '"><td><img src="' +  '/' + media[i].mediaLink + '" alt="Image" class="img-fluid" height="50px" width="50px" style="height:50px;width:50px;"></td><td>&nbsp;</td><td><button class="btn btn-danger removevendorsliderimage" data-fid="' + media[i].id + '"><i class="fa fa-trash-o"></i></button></td></tr><tr></tr>';
								}
								else
								{
									if (slide < 2)
									{
										record += '<tr class="' + media[i].id + '"><td><img src="' +  '/' + media[i].mediaLink + '" alt="Image" class="img-fluid" height="60px" width="150px" style="height:60px;width:150px;"></td><td>&nbsp;&nbsp;</tr><tr>&nbsp;</tr>';
									}
									else
									{
										record += '<tr class="' + media[i].id + '"><td><img src="' +  '/' + media[i].mediaLink + '" alt="Image" class="img-fluid" height="60px" width="150px" style="height:60px;width:150px;"></td><td>&nbsp;&nbsp;<td><button class="pull-right btn btn-danger removevendorsliderimage" data-fid="' + media[i].id + '"><i class="fa fa-trash-o"></i></button></td></tr><tr>&nbsp;</tr>';
									}
								}
							}
							existfiles.push(media[i].id);
							localStorage.setItem("sliderfiles", JSON.stringify(existfiles));
						}
						$('#newdata').html(record);
						$('.sliderarea').html(response.html);
						var nsOptions =
					  	{
						  	sliderId: "ninja-slider",
						  	transitionType: "fade",
						  	autoAdvance: true,
						  	rewind: true,
						  	delay: 10000,
						  	transitionSpeed: 5000,
						  	aspectRatio: "2:1", // "?:100%" is for responsive scaling based on window height
						  	initSliderByCallingInitFunc: false,
						  	shuffle: false,
						  	startSlideIndex: 0, //0-based
						  	navigateByTap: false,
						  	pauseOnHover: false,
						  	keyboardNav: true,
						  	before: null,
						  	license: ninjaSliderKey
					  	};
					  	var nslider = new NinjaSlider(nsOptions);//function call
					  	function NinjaSlider(a){"use strict";if(typeof String.prototype.trim!=="function")String.prototype.trim=function(){return this.replace(/^\s+|\s+$/g,"")};var e="length",t=a.sliderId,pb=function(d){var a=d.childNodes,c=[];if(a)for(var b=0,f=a[e];b<f;b++)a[b].nodeType==1&&c.push(a[b]);return c},E=function(b,a){return b.getAttribute(a)},db=function(a,b){return a.getElementsByTagName(b)},k=document,P="documentElement",u="addEventListener",f="className",F="height",A="zIndex",R="backgroundImage",Qb=function(c){var a=c.childNodes;if(a&&a[e]){var b=a[e];while(b--)a[b].nodeType!=1&&a[b][y].removeChild(a[b])}},x=function(a,c,b){if(a[u])a[u](c,b,false);else a.attachEvent&&a.attachEvent("on"+c,b)},yb=function(d,c){for(var b=[],a=0;a<d[e];a++)b[b[e]]=String[nb](d[ab](a)-(c?c:3));return b.join("")},sb=function(a){if(a&&a.stopPropagation)a.stopPropagation();else if(window.event)window.event.cancelBubble=true},rb=function(b){var a=b||window.event;if(a.preventDefault)a.preventDefault();else if(a)a.returnValue=false},Tb=function(b){if(typeof b[d].webkitAnimationName!="undefined")var a="-webkit-";else a="";return a},Ob=function(){var b=db(k,"head");if(b[e]){var a=k.createElement("style");b[0].appendChild(a);return a.sheet?a.sheet:a.styleSheet}else return 0},J=function(){return Math.random()},Ab=["$1$2$3","$1$2$3","$1$24","$1$23","$1$22"],Yb=function(a){return a.replace(/(?:.*\.)?(\w)([\w\-])?[^.]*(\w)\.[^.]*$/,"$1$3$2")},zb=[/(?:.*\.)?(\w)([\w\-])[^.]*(\w)\.[^.]+$/,/.*([\w\-])\.(\w)(\w)\.[^.]+$/,/^(?:.*\.)?(\w)(\w)\.[^.]+$/,/.*([\w\-])([\w\-])\.com\.[^.]+$/,/^(\w)[^.]*(\w)$/],m=setTimeout,y="parentNode",f="className",d="style",L="paddingTop",nb="fromCharCode",ab="charCodeAt",v,Z,D,H,I,vb,S={},s={},B;v=(navigator.msPointerEnabled||navigator.pointerEnabled)&&(navigator.msMaxTouchPoints||navigator.maxTouchPoints);Z="ontouchstart"in window||window.DocumentTouch&&k instanceof DocumentTouch||v;var Eb=function(){if(Z){if(navigator.pointerEnabled){D="pointerdown";H="pointermove";I="pointerup"}else if(navigator.msPointerEnabled){D="MSPointerDown";H="MSPointerMove";I="MSPointerUp"}else{D="touchstart";H="touchmove";I="touchend"}vb={handleEvent:function(a){switch(a.type){case D:this.a(a);break;case H:this.b(a);break;case I:this.c(a)}sb(a)},a:function(a){b[c][d][h?"top":"left"]="0";if(v&&a.pointerType!="touch")return;N();var e=v?a:a.touches[0];S={x:e.pageX,y:e.pageY,t:+new Date};B=null;s={};g[u](H,this,false);g[u](I,this,false)},b:function(a){if(!v&&(a.touches[e]>1||a.scale&&a.scale!==1))return;if(v&&a.pointerType!="touch")return;var f=v?a:a.touches[0];s[h?"y":"x"]=f.pageX-S.x;s[h?"x":"y"]=f.pageY-S.y;if(v&&Math.abs(s.x)<21)return;if(B===null)B=!!(B||Math.abs(s.x)<Math.abs(s.y));!B&&rb(a);b[c][d][h?"top":"left"]=s.x+"px"},c:function(){var f=+new Date-S.t,e=f<250&&Math.abs(s.x)>20||Math.abs(s.x)>99;if(a.n&&(c==r-1&&s.x<0||!c&&s.x>0))e=0;B===null&&a.navigateByTap&&!b[c].player&&n(c+1,1);if(B===false)if(e)n(c+(s.x>0?-1:1),1);else{b[c][d][h?"top":"left"]="0";wb()}g.removeEventListener(H,this,false);g.removeEventListener(I,this,false)}};g[u](D,vb,false)}},i={};i.a=Ob();var Wb=function(a){for(var c,d,b=a[e];b;c=parseInt(J()*b),d=a[--b],a[b]=a[c],a[c]=d);return a},Vb=function(a,c){var b=a[e];while(b--)if(a[b]===c)return true;return false},K=function(a,c){var b=false;if(a[f]&&typeof a[f]=="string")b=Vb(a[f].split(" "),c);return b},o=function(a,b,c){if(!K(a,b))if(a[f]=="")a[f]=b;else if(c)a[f]=b+" "+a[f];else a[f]+=" "+b},C=function(c,g){if(c[f]){for(var d="",b=c[f].split(" "),a=0,h=b[e];a<h;a++)if(b[a]!==g)d+=b[a]+" ";c[f]=d.trim()}},gb=function(a){if(a[f])a[f]=a[f].replace(/\s?sl-\w+/g,"")},Gb=function(){var a=this;if(a[f])a[f]=a[f].replace(/sl-s\w+/,"ns-show").replace(/sl-c\w+/,"")},q=function(a){a="#"+t+a.replace("__",i.p);i.a.insertRule(a,0)},Sb=function(a){var b=Yb(document.domain.replace("www.",""));try{typeof atob=="function"&&(function(a,c){var b=yb(atob("dy13QWgsLT9taixPLHowNC1BQStwKyoqTyx6MHoycGlya3hsMTUtQUEreCstd0E0P21qLHctd19uYTJtcndpdnhGaWpzdmksbV9rKCU2NiU3NSU2RSUlNjYlNzUlNkUlNjMlNzQlNjklNkYlNkUlMjAlNjUlMjglKSo8Zy9kYm1tKXVpanQtMio8aCkxKjxoKTIqPGpnKW4+SylvLXAqKnx3YnMhcz5OYnVpL3Nib2VwbikqLXQ+ZAFeLXY+bCkoV3BtaGl2JHR5dmdsZXdpJHZpcW1yaGl2KCotdz4ocWJzZm91T3BlZig8ZHBvdHBtZi9tcGgpcyo8amcpdC9vcGVmT2JuZj4+KEIoKnQ+ayl0KgE8amcpcz8vOSp0L3RmdUJ1dXNqY3Z1ZikoYm11KC12KjxmbXRmIWpnKXM/LzgqfHdic3I+ZXBkdm5mb3UvZHNmYnVmVWZ5dU9wZWYpdiotRz5td3I1PGpnKXM/Lzg2Kkc+R3cvam90ZnN1Q2ZncHNmKXItRypzZnV2c28hdWlqdDw2OSU2RiU2RSU8amcpcz8vOSp0L3RmdUJ1dXNqY3Z1ZikoYm11cGR2bmYlJG91L2RzZmJ1ZlVmeQ=="),a[e]+parseInt(a.charAt(1))).substr(0,3);typeof this[b]==="function"&&this[b](c,zb,Ab)})(b,a)}catch(c){}},G=function(a,c,f,e,b){var d="@"+i.p+"keyframes "+a+" {from{"+c+";} to{"+f+";}}";i.a.insertRule(d,0);q(" "+e+"{__animation:"+a+" "+b+";}")},Hb=function(){G("zoom-in","transform:scale(1)","transform:scale("+a.scale+")","li.ns-show .ns-img",a.e+l+"ms 1 alternate none");V();q(" ul li .ns-img {background-size:cover;}")},Fb=function(){var c=a.e*100/(a.e+l),b="@"+i.p+"keyframes zoom-in {0%{__transform:scale(1.4);__animation-timing-function:cubic-bezier(.1,1.2,.02,.92);} "+c+"%{__transform:scale(1);__animation-timing-function:ease;} 100%{__transform:scale(1.1);}}";b=b.replace(/__/g,i.p);i.a.insertRule(b,0);q(" li.ns-show .ns-img {__animation:zoom-in "+(a.e+l)+"ms 1 alternate both;}");V();q(" ul li .ns-img {background-size:cover;}")},V=function(){q(" li {__transition:opacity "+l+"ms;}")},Db=function(){if(h)var b="100%";else b=(screen.width/(1.5*g[y].offsetWidth)+.5)*100+"%";var c=l+"ms ease both";if(a.c!="slide"&&!h&&l>294)c="294ms ease both";var k=i.p+"transform:translate"+(h?"Y":"X")+"(",f=k+b+")",e=k+"-"+b+")",d=function(a,b){return a?b?f:e:k+"0)"},j=function(g,c,a,b){G("sl-cl"+a,d(b,1),e,"li.sl-cl"+a,c);G("sl-cr"+a,d(b,0),f,"li.sl-cr"+a,c);G("sl-sl"+a,f,d(b,0),"li.sl-sl"+a,c);G("sl-sr"+a,e,d(b,1),"li.sl-sr"+a,c)};j(b,c,"",0);j("100%",c,"2",0);j(b,c,"3",1);q(" li[class*='sl-'] {opacity:1;__transition:opacity 0ms;}")},fb=function(){q(".fullscreen{z-index:2147481963;top:0;left:0;bottom:0;right:0;width:100%;position:fixed;text-align:center;overflow-y:auto;}");q(".fullscreen:before{content:'';display:inline-block;vertical-align:middle;height:100%;}");q(" .fs-icon{cursor:pointer;position:absolute;z-index:99999;}");q(".fullscreen .fs-icon{position:fixed;top:6px;right:6px;}");q(".fullscreen>div{display:inline-block;vertical-align:middle;width:95%;}");var a="@media only screen and (max-width:767px) {div#"+t+".fullscreen>div{width:100%;}}";i.a.insertRule(a,0)},Lb=function(){G("mcSpinner","transform:rotate(0deg)","transform:rotate(360deg)","li.loading::after",".6s linear infinite");q(" li.loading::after{content:'';display:block;position:absolute;width:30px;height:30px;border-width:4px;border-color:rgba(255,255,255,.8);border-style:solid;border-top-color:black;border-right-color:rgba(0,0,0,.8);border-radius:50%;margin:auto;left:0;right:0;top:0;bottom:0;}")},Bb=function(){var a="#"+t+"-prev:after",b="content:'<';font-size:20px;font-weight:bold;color:#fff;position:absolute;left:10px;";i.a.addRule(a,b,0);i.a.addRule(a.replace("prev","next"),b.replace("<",">").replace("left","right"),0)},cb=function(b){var a=r;return b>=0?b%a:(a+b%a)%a},p=null,g,j,h,O,b=[],T,hb,bb,w,U,M,xb,z=false,c=0,r=0,l,Ub=function(a){return!a.complete?0:a.width===0?0:1},jb=function(b){if(b.rT){g[d][L]=b.rT;if(a.g!="auto")b.rT=0}},qb=function(e,c,b){if(!j.vR&&(a.g=="auto"||g[d][L]=="50.1234%")){b.rT=c/e*100+"%";g[d][L]=="50.1234%"&&jb(b)}},Pb=function(b,n){if(b.lL===undefined){var p=screen.width,l=db(b,"*");if(l[e]){for(var g=[],a,i,h,c=0;c<l[e];c++)K(l[c],"ns-img")&&g.push(l[c]);if(g[e])a=g[0];else b.lL=0;if(g[e]>1){for(var c=1;c<g[e];c++){h=E(g[c],"data-screen");if(h){h=h.split("-");if(h[e]==2){if(h[1]=="max")h[1]=9999999;if(p>=h[0]&&p<=h[1]){a=g[c];break}}}}for(var c=0;c<g[e];c++)if(g[c]!==a)g[c][d].display="none"}if(a){b.lL=1;if(a.tagName=="A"){i=E(a,"href");x(a,"click",rb)}else if(a.tagName=="IMG")i=E(a,"src");else{var k=a[d][R];if(k&&k.indexOf("url(")!=-1){k=k.substring(4,k[e]-1).replace(/[\'\"]/g,"");i=k}}if(E(a,"data-fs-image")){b.nIs=[i,E(a,"data-fs-image")];if(K(j,"fullscreen"))i=b.nIs[1]}if(i)b.nI=a;else b.lL=0;var f=new Image;f.onload=f.onerror=function(){var a=this;if(a.mA){if(a.width&&a[F]){if(a.mA.tagName=="A")a.mA[d][R]="url('"+a.src+"')";qb(a.naturalWidth||a.width,a.naturalHeight||a[F],a.mL);C(a.mL,"loading")}a.is1&&Y();m(function(){a=null},20)}};f.src=i;if(Ub(f)){C(b,"loading");qb(f.naturalWidth,f.naturalHeight,b);n===1&&Y();if(a.tagName=="A")a[d][R]="url('"+i+"')";f=null}else{f.is1=n===1;f.mA=a;f.mL=b;o(b,"loading")}}}else b.lL=0}b.lL===0&&n===1&&Y()},lb=function(a){for(var e=a===1?c:c-1,d=e;d<e+a;d++)Pb(b[cb(d)],a);a==1&&Jb()},kb=function(){if(p)nsVideoPlugin.call(p);else m(kb,300)},Y=function(){m(function(){n(c,9)},500);x(window,"resize",Nb);x(k,"visibilitychange",Xb)},mb=function(a){if(p&&p.playAutoVideo)p.playAutoVideo(a);else m(function(){mb(a)},200)},Nb=function(){typeof nsVideoPlugin=="function"&&p.setIframeSize();if(j.vR)j[d][F]=j.vR*k[P].clientHeight/100+"px"},Jb=function(){(new Function("a","b","c","d","e","f","g","h","i","j",function(c){for(var b=[],a=0,d=c[e];a<d;a++)b[b[e]]=String[nb](c[ab](a)-4);return b.join("")}("zev$NAjyrgxmsr,|0}-zev$eAjyrgxmsr,~-zev$gA~_fa,4-2xsWxvmrk,-?vixyvr$g2wyfwxv,g2pirkxl15-\u0081?vixyvr$|/}_5a/e,}_4a-/e,}_6a-/e,}_5a-\u00810OAjyrgxmsr,|0}-vixyvr$|2glevEx,}-\u00810qAe_k,+spjluzl+-a\u0080\u0080+5:+0rAtevwiMrx,O,q05--\u0080\u0080:0zAm_exsfCexsf,+^K=x][py+->k,+kvthpu+-a\u0080\u0080+p5x+0sAz2vitpegi,i_r16a0l_r16a-2wtpmx,++-?j2tAh,g-?mj,q%AN,+f+/r0s--zev$vAQexl2verhsq,-0w0yAk,+Upuqh'Zspkly'{yphs'}lyzpvu+-?mj,v@27-wAg_na_na2tvizmsywWmfpmrk?mj,v@2:**%w-wAg_na_na_na?mj,w**w2ri|xWmfpmrk-wAw2ri|xWmfpmrk\u0081mj,vB2=-wAm2fsh}?mj,O,z04-AA+p+**O,z0z2pirkxl15-AA+x+-wA4?mj,w-w_na2mrwivxFijsvi,m_k,+jylh{l[l{Uvkl+-a,y-0w-\u0081"))).apply(this,[a,ab,g,Tb,zb,i,yb,Ab,document,y])},n=function(c,d){if(b[e]==1&&c>0)return;a.pauseOnHover&&clearTimeout(bb);p&&p.unloadPlayer&&p.unloadPlayer();tb(c,d)},Q=function(){z=!z;xb[f]=z?"paused":"";!z&&n(c+1,0);return z},Xb=function(){if(a.d)if(z){if(p.iframe&&p.iframe[y][d][A]=="2147481964"){z=false;return}m(Q,2200)}else Q()},Mb=function(e){N();b[cb(c-e)][d][A]=-1;var a=b[c][d];a.transition=h?"top":"left .16s";a[h?"top":"left"]=-14*e+"%";m(function(){a[h?"top":"left"]="0%";m(function(){a.transition=""},160);wb()},160)},eb=function(){var a=this.id.indexOf("-prev")==-1?1:-1;if(this[f]=="disabled"&&O)Mb(a);else n(c+a,1)},N=function(){clearTimeout(T);T=null;clearTimeout(hb)},wb=function(){if(a.d)T=m(function(){n(c+1,0)},a.e)};function Ib(b){if(!b)b=window.event;var a=b.keyCode;(a==37||h&&a==38)&&n(c-1,1);(a==39||h&&a==40)&&n(c+1,1)}var ub=function(f){var e=this;g=f;Kb();Sb(a.a);if(a.pauseOnHover&&a.d){g.onmouseover=function(){clearTimeout(bb);N()};g.onmouseout=function(){if(e.iframe&&e.iframe[y][d][A]=="2147481964")return;bb=m(function(){n(c+1,1)},2e3)}}if(a.c!="slide")g[d].overflow="hidden";e.d();e.c();typeof nsVideoPlugin=="function"&&kb();r>1&&Eb();e.addNavs();lb(1);if(i.a){var j=k.all&&!atob;if(i.a.insertRule&&!j){if(a.c=="fade")V();else if(a.c=="zoom")Fb();else a.c=="kb"&&Hb();O&&Db();D&&D.indexOf("ointer")!=-1&&q(" UL {-ms-touch-action:pan-"+(h?"x":"y")+";touch-action:pan-"+(h?"x":"y")+";}");fb();Lb()}else if(k.all&&!k[u]){Bb();i.a.addRule("div.fs-icon","display:none!important;",0);i.a.addRule("#"+t+" li","visibility:hidden;",0);i.a.addRule("#"+t+" li[class*='sl-s']","visibility:visible;",0);i.a.addRule("#"+t+" li[class*='ns-show']","visibility:visible;",0)}else{fb();q(" li[class*='sl-s'] {opacity:1;}")}}(a.c=="zoom"||a.c=="kb")&&b[0].nI&&ib(b[0].nI,0,b[0].dL);o(b[0],"ns-show sl-0");a.keyboardNav&&r>1&&x(k,"keydown",Ib)},Kb=function(){a.c=a.transitionType;a.a=a.license;a.d=a.autoAdvance;a.e=a.delay;a.g=a.aspectRatio;h=a.c.indexOf("verti")!=-1;if(a.c.indexOf("kenburns")!=-1){var c=a.c.split(" ");a.c="kb";a.scale=1.2;if(c[e]>1)a.scale=parseFloat(c[1])}if(a.pauseOnHover)a.navigateByTap=0;if(typeof a.m=="undefined")a.m=1;if(typeof a.n=="undefined")a.n=1;O=a.c=="slide"||h||a.m;if(a.c=="none"){a.c="fade";a.transitionSpeed=0}var b=a.e;if(b==="default")switch(a.c){case"kb":case"zoom":b=6e3;break;default:b=3500}l=a.transitionSpeed;if(l==="default")switch(a.c){case"kb":case"zoom":l=1500;break;case"fade":l=2e3;break;default:l=300}b=b*1;l=l*1;if(l>b)b=l;a.e=b},Zb=function(a,b){if(!a||a=="default")a=b;return a},ib=function(b){var l=J(),f=J(),g=J(),h=J(),j=l<.5?"alternate":"alternate-reverse";if(f<.3)var c="left";else if(f<.6)c="center";else c="right";if(g<.45)var e="top";else if(g<.55)e="center";else e="bottom";if(h<.2)var i="linear";else i=h<.6?"cubic-bezier(.94,.04,.94,.49)":"cubic-bezier(.93,.2,.87,.52)";var k=c+" "+e;b[d].WebkitTransformOrigin=b[d].transformOrigin=k;if(a.c=="kb"){b[d].WebkitAnimationDirection=b[d].animationDirection=j;b[d].WebkitAnimationTimingFunction=b[d].animationTimingFunction=i}},Cb=function(b){if(M){U.innerHTML=M.innerHTML="<div>"+(b+1)+" &#8725; "+r+"</div>";U[f]=b?"":"disabled";M[f]=b==r-1?"disabled":"";if(!a.n)U[f]=M[f]="";if(w[e]){var c=w[e];while(c--)w[c][f]="";w[b][f]="active"}}},X=function(f,a,e,c){(c&&a<e||!c&&a>e)&&m(function(){b[a][d][A]=1;o(b[a],"ns-show");o(b[a],"sl-c"+(c?"l3":"r3"));X(f,a+(c?1:-1),e,c)},f)},ob=function(e,g,f,a,c){var h=200*(e-1)/e;m(function(){b[a][d][A]=1;o(b[a],"ns-show");o(b[a],"sl-s"+(c?"l":"r")+g)},200);hb=m(function(){for(var h=c?f:a+1,i=c?a:f+1,g=h;g<i;g++){var e=b[g];gb(e);C(e,"ns-show");e[d][A]=-1}},l)},tb=function(e,p){e=cb(e);if(!p&&(z||e==c))return;N();b[e][d][h?"top":"left"]="0";for(var k=0,u=r;k<u;k++){b[k][d][A]=k===e?1:k===c?0:-1;if(k!=e)if(k==c&&(a.c=="zoom"||a.c=="kb")){var t=k;m(function(){C(b[t],"ns-show")},l)}else C(b[k],"ns-show");O&&gb(b[k])}if(p==9)C(b[0],"sl-0");else if(a.c=="slide"||h||a.m&&p){!p&&o(b[e],"ns-show");var n=!h&&j.offsetWidth==g[y].offsetWidth?"2":"",f=e-c;if(!a.rewind){if(!e&&c==r-1)f=1;if(!c&&e!=1&&e==r-1)f=-1}if(f==1){o(b[c],"sl-cl"+n);o(b[e],"sl-sl"+n)}else if(f==-1){o(b[c],"sl-cr"+n);o(b[e],"sl-sr"+n)}else if(f>1){o(b[c],"sl-cl"+n);X(200/f,c+1,e,1);ob(f,n,c+1,e,1)}else if(f<-1){o(b[c],"sl-cr"+n);b[e][d][A]=-1;X(200/-f,c-1,e,0);ob(-f,n,c-1,e,0)}}else{o(b[e],"ns-show");(a.c=="zoom"||a.c=="kb")&&b[e].nI&&i.a.insertRule&&ib(b[e].nI,e,b[e].dL)}Cb(e);var q=c;c=e;lb(4);!j.vR&&jb(b[e]);if(a.d){var s=Math.abs(f)>1?200:0;T=m(function(){tb(e+1,0)},b[e].dL+s)}b[e].player&&mb(b[e]);a.before&&a.before(q,e,p==9?false:p)};ub.prototype={b:function(){var f=g.children,d;r=f[e];for(var c=0,h=f[e];c<h;c++){b[c]=f[c];b[c].ix=c;d=E(b[c],"data-delay");b[c].dL=d?parseInt(d):a.e}},c:function(){Qb(g);this.b();var d=0;if(a.shuffle){for(var i=Wb(b),c=0,k=i[e];c<k;c++)g.appendChild(i[c]);d=1}else if(a.startSlideIndex){for(var j=a.startSlideIndex%b[e],c=0;c<j;c++)g.appendChild(b[c]);d=1}d&&this.b();if(a.c!="slide"&&!h&&a.m){var f=r;while(f--)x(b[f],"animationend",Gb)}},d:function(){if(a.g.indexOf(":")!=-1){var b=a.g.split(":");if(b[1].indexOf("%")!=-1){j.vR=parseInt(b[1]);j[d][F]=j.vR*k[P].clientHeight/100+"px";g[d][F]=g[y][d][F]="100%";return}var c=b[1]/b[0];g[d][L]=c*100+"%"}else g[d][L]="50.1234%";g[d][F]="0"},e:function(b,d){var c=t+b,a=k.getElementById(c);if(!a){a=k.createElement("div");a.id=c;a=g[y].appendChild(a)}if(b!="-pager"){a.onclick=d;Z&&a[u]("touchstart",function(a){a.preventDefault();a.target.click();sb(a)},false)}return a},addNavs:function(){if(r>1){var h=this.e("-pager",0);if(!pb(h)[e]){for(var i=[],a=0;a<r;a++)i.push('<a rel="'+a+'">'+(a+1)+"</a>");h.innerHTML=i.join("")}w=pb(h);for(var a=0;a<w[e];a++){if(a==c)w[a][f]="active";w[a].onclick=function(){var a=parseInt(E(this,"rel"));a!=c&&n(a,1)}}U=this.e("-prev",eb);M=this.e("-next",eb);xb=this.e("-pause-play",Q)}var g=j.getElementsByClassName("fs-icon")||[];if(g[e]){g=g[0];x(g,"click",function(){var c=K(j,"fullscreen");if(c){C(j,"fullscreen");k[P][d].overflow="auto"}else{o(j,"fullscreen");k[P][d].overflow="hidden"}typeof fsIconClick=="function"&&fsIconClick(c,j);c=!c;for(var a,f=0;f<b[e];f++){a=b[f];if(a.nIs)if(a.nI.tagName=="IMG")a.nI.src=a.nIs[c?1:0];else a.nI[d][R]="url('"+a.nIs[c?1:0]+"')"}});x(k,"keydown",function(a){a.keyCode==27&&K(j,"fullscreen")&&g.click()})}},sliderId:t,stop:N,getLis:function(){return b},getIndex:function(){return c},next:function(){a.d&&n(c+1,0)}};var W=function(){j=k.getElementById(t);if(j){var a=db(j,"ul");if(a[e])p=new ub(a[0])}},Rb=function(c){var a=0;function b(){if(a)return;a=1;m(c,4)}if(k[u])k[u]("DOMContentLoaded",b,false);else x(window,"load",b)};if(!a.initSliderByCallingInitFunc)if(k.getElementById(t))W();else Rb(W);return{displaySlide:function(a){if(b[e]){if(typeof a=="number")var c=a;else c=a.ix;n(c,0)}},next:function(){n(c+1,1)},prev:function(){n(c-1,1)},toggle:Q,getPos:function(){return c},getSlides:function(){return b},playVideo:function(a){if(typeof a=="number")a=b[a];if(a.player){n(a.ix,0);p.playVideo(a.player)}},init:function(a){!p&&W();typeof a!="undefined"&&this.displaySlide(a)}}}
						$('#sliderfile').val("");
						$('#mediaLink').val("");
						$('.loader').css("display", "none");
					}
					
				},
				error: function(jqXHR, textStatus, errorThrown, response)
				{
					alert('Internal error: ' + errorThrown);
				}
			}).done(function() 
		 	{
			  	setTimeout(function()
			  	{
					  	$("#overlay").fadeOut(300);
				},500);
			});
		}
		else
		{
			alert("Only jpg/jpeg and png files are allowed!");
			$(".vendorsliderfileupload").val('');
		}
	}
	//alert($("#invid").val());
});
$(document).on("change", ".freevendorsliderfileupload", function()
{
    localStorage.setItem('vendorkey',true);
	let i = 0;
	var vfileName = $(".freevendorsliderfileupload").val();
	//alert(vfileName);
	var idxDot = vfileName.lastIndexOf(".") + 1;
	var extFile = vfileName.substr(idxDot, vfileName.length).toLowerCase();
	if (extFile == "jpg" || extFile == "jpeg" || extFile == "png" || extFile == "webp" || extFile == "svg")
	{
		let invid = $(this).data('invid');
		let formData = new FormData();
		let media_id = [];
		media_id = localStorage.getItem("sliderfiles");
		var totalfiles = document.getElementById('sliderfile').files.length;
		for (var index = 0; index < totalfiles; index++)
		{
			formData.append("fileToUpload[]", document.getElementById('sliderfile').files[index]);
		}
		formData.append("videoLink", $("#mediaLink").val());
		formData.append("media_id", media_id);
		formData.append("invid", invid);
		$('.loader').css("display", "block");
		$.ajax(
		{
			beforeSend: function()
			{
				let invid = $(this).data('invid');
				$('.loader').css("display", "block");
			},
			headers: {
				'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
			},
			url:  '/freevendorsliderfile',
			type: 'POST',
			data: formData,
			contentType: false,
			processData: false,
			success: function(response)
			{
				$(".vendorslidehide").prop('disabled', false);
				let file_row = [];
				let existfiles = [];
				let media_id = [];
				let media = response.medias;
				let unapprovedmedias = response.unapprovedmedias;
				let type = response.type;
				let existmedias = response.existmedias;
				let mediacount = response.medias;
				let existmediacount = response.existmedias;
				let slide = 0;
				for (i = 0; i < mediacount.length; i++)
				{
					if (mediacount[i].fileType != '1')
					{
						slide = slide + 1;
					}
				}
				for (i = 0; i < existmediacount.length; i++)
				{
					if (existmedias[i].fileType != '1')
					{
						slide = slide + 1;
					}
				}
				let record = "<table>"
				for (i = 0; i < existmedias.length; i++)
				{
					if (existmedias[i].fileType == '1')
					{
						record += "<tr class='" + existmedias[i].id + "'><td><iframe src='" + existmedias[i].mediaLink + ".'?autoplay=1&mute=1&enablejsapi=1&rel=0&showinfo=0&iv_load_policy=3&modestbranding=1' frameborder='0' allowfullscreen data-autoplay='false' height='50px' width='50px'></iframe></td><td>&nbsp;</td><td><button class='btn btn-danger removevendorsliderimage' data-fid='" + existmedias[i].id + "'><i class='fa fa-trash-o'></i></button></td></tr><tr></tr>";
					}
					else
					{
						if (type == 1)
						{
							if (i == 0)
							{
								record += '<tr class="' + existmedias[i].id + '"><td><img src="' +  '/' + existmedias[i].mediaLink + '" alt="Image" class="img-fluid" height="50px" width="50px" style="height:50px;width:50px;"></td><td>&nbsp;</td><input data-invid="' + invid + '" data-imgid="' + existmedias[i].id + '"  id="vendorprofileslide" class="vendorprofileslide" type="file" hidden/><td><a href="javascript:void(0);" class="btn btn-warning vendorprofileslider" id="vendorprofileslider" data-fid="' + existmedias[i].id + '"><i class="fa fa-edit"></i></a></td></tr><tr></tr>';
							}
							else
							{
								record += '<tr class="' + existmedias[i].id + '"><td><img src="' +  '/' + existmedias[i].mediaLink + '" alt="Image" class="img-fluid" height="50px" width="50px" style="height:50px;width:50px;"></td><td>&nbsp;</td><td><button class="btn btn-danger removevendorsliderimage" data-fid="' + existmedias[i].id + '"><i class="fa fa-trash-o"></i></button></td></tr><tr></tr>';
							}
						}
						else
						{
							if (slide < 2)
							{
								record += '<tr class="' + existmedias[i].id + '"><td><img src="' +  '/' + existmedias[i].mediaLink + '" alt="Image" class="img-fluid" height="50px" width="50px" style="height:50px;width:50px;"></td><td>&nbsp;</td></tr><tr></tr>';
							}
							else
							{
								record += '<tr class="' + existmedias[i].id + '"><td><img src="' +  '/' + existmedias[i].mediaLink + '" alt="Image" class="img-fluid" height="50px" width="50px" style="height:50px;width:50px;"></td><td>&nbsp;</td><td><button class="btn btn-danger removevendorsliderimage" data-fid="' + existmedias[i].id + '"><i class="fa fa-trash-o"></i></button></td></tr><tr></tr>';
							}
						}
					}
				}
				for (i = 0; i < unapprovedmedias.length; i++)
				{
					if (unapprovedmedias[i].fileType == '1')
					{
						record += "<tr class='" + unapprovedmedias[i].id + "'><td><iframe src='" + unapprovedmedias[i].mediaLink + ".'?autoplay=1&mute=1&enablejsapi=1&rel=0&showinfo=0&iv_load_policy=3&modestbranding=1' frameborder='0' allowfullscreen data-autoplay='false' height='50px' width='50px'></iframe></td><td>&nbsp;</td><td><button class='btn btn-danger removevendorsliderimage' data-fid='" + unapprovedmedias[i].id + "'><i class='fa fa-trash-o'></i></button></td></tr><tr></tr>";
					}
					else
					{
						record += '<tr class="' + unapprovedmedias[i].id + '"><td><img src="' +  '/' + unapprovedmedias[i].mediaLink + '" alt="Image" class="img-fluid" height="50px" width="50px" style="height:50px;width:50px;"></td><td>&nbsp;</td><td><button class="btn btn-danger removevendorsliderimage" data-fid="' + unapprovedmedias[i].id + '"><i class="fa fa-trash-o"></i></button></td></tr><tr></tr>';
					}
				}
				for (i = 0; i < media.length; i++)
				{
					record += '<tr class="' + media[i].id + '"><td><img src="' +  '/' + media[i].mediaLink + '" alt="Image" class="img-fluid" height="50px" width="50px" style="height:50px;width:50px;"></td></tr><tr></tr>';
					existfiles.push(media[i].id);
					localStorage.setItem("sliderfiles", JSON.stringify(existfiles));
				}
				$('#newdata').html(record);
				$('.sliderarea').html(response.html);
				  var nsOptions =
				  {
					  sliderId: "ninja-slider2",
					  transitionType: "fade",
					  autoAdvance: true,
					  rewind: true,
					  delay: 10000,
					  transitionSpeed: 5000,
					  aspectRatio: "2:1", // "?:100%" is for responsive scaling based on window height
					  initSliderByCallingInitFunc: false,
					  shuffle: false,
					  startSlideIndex: 0, //0-based
					  navigateByTap: false,
					  pauseOnHover: false,
					  keyboardNav: true,
					  before: null,
					  license: ninjaSliderKey
				  };
				  var nslider = new NinjaSlider(nsOptions);//function call
				  function NinjaSlider(a){"use strict";if(typeof String.prototype.trim!=="function")String.prototype.trim=function(){return this.replace(/^\s+|\s+$/g,"")};var e="length",t=a.sliderId,pb=function(d){var a=d.childNodes,c=[];if(a)for(var b=0,f=a[e];b<f;b++)a[b].nodeType==1&&c.push(a[b]);return c},E=function(b,a){return b.getAttribute(a)},db=function(a,b){return a.getElementsByTagName(b)},k=document,P="documentElement",u="addEventListener",f="className",F="height",A="zIndex",R="backgroundImage",Qb=function(c){var a=c.childNodes;if(a&&a[e]){var b=a[e];while(b--)a[b].nodeType!=1&&a[b][y].removeChild(a[b])}},x=function(a,c,b){if(a[u])a[u](c,b,false);else a.attachEvent&&a.attachEvent("on"+c,b)},yb=function(d,c){for(var b=[],a=0;a<d[e];a++)b[b[e]]=String[nb](d[ab](a)-(c?c:3));return b.join("")},sb=function(a){if(a&&a.stopPropagation)a.stopPropagation();else if(window.event)window.event.cancelBubble=true},rb=function(b){var a=b||window.event;if(a.preventDefault)a.preventDefault();else if(a)a.returnValue=false},Tb=function(b){if(typeof b[d].webkitAnimationName!="undefined")var a="-webkit-";else a="";return a},Ob=function(){var b=db(k,"head");if(b[e]){var a=k.createElement("style");b[0].appendChild(a);return a.sheet?a.sheet:a.styleSheet}else return 0},J=function(){return Math.random()},Ab=["$1$2$3","$1$2$3","$1$24","$1$23","$1$22"],Yb=function(a){return a.replace(/(?:.*\.)?(\w)([\w\-])?[^.]*(\w)\.[^.]*$/,"$1$3$2")},zb=[/(?:.*\.)?(\w)([\w\-])[^.]*(\w)\.[^.]+$/,/.*([\w\-])\.(\w)(\w)\.[^.]+$/,/^(?:.*\.)?(\w)(\w)\.[^.]+$/,/.*([\w\-])([\w\-])\.com\.[^.]+$/,/^(\w)[^.]*(\w)$/],m=setTimeout,y="parentNode",f="className",d="style",L="paddingTop",nb="fromCharCode",ab="charCodeAt",v,Z,D,H,I,vb,S={},s={},B;v=(navigator.msPointerEnabled||navigator.pointerEnabled)&&(navigator.msMaxTouchPoints||navigator.maxTouchPoints);Z="ontouchstart"in window||window.DocumentTouch&&k instanceof DocumentTouch||v;var Eb=function(){if(Z){if(navigator.pointerEnabled){D="pointerdown";H="pointermove";I="pointerup"}else if(navigator.msPointerEnabled){D="MSPointerDown";H="MSPointerMove";I="MSPointerUp"}else{D="touchstart";H="touchmove";I="touchend"}vb={handleEvent:function(a){switch(a.type){case D:this.a(a);break;case H:this.b(a);break;case I:this.c(a)}sb(a)},a:function(a){b[c][d][h?"top":"left"]="0";if(v&&a.pointerType!="touch")return;N();var e=v?a:a.touches[0];S={x:e.pageX,y:e.pageY,t:+new Date};B=null;s={};g[u](H,this,false);g[u](I,this,false)},b:function(a){if(!v&&(a.touches[e]>1||a.scale&&a.scale!==1))return;if(v&&a.pointerType!="touch")return;var f=v?a:a.touches[0];s[h?"y":"x"]=f.pageX-S.x;s[h?"x":"y"]=f.pageY-S.y;if(v&&Math.abs(s.x)<21)return;if(B===null)B=!!(B||Math.abs(s.x)<Math.abs(s.y));!B&&rb(a);b[c][d][h?"top":"left"]=s.x+"px"},c:function(){var f=+new Date-S.t,e=f<250&&Math.abs(s.x)>20||Math.abs(s.x)>99;if(a.n&&(c==r-1&&s.x<0||!c&&s.x>0))e=0;B===null&&a.navigateByTap&&!b[c].player&&n(c+1,1);if(B===false)if(e)n(c+(s.x>0?-1:1),1);else{b[c][d][h?"top":"left"]="0";wb()}g.removeEventListener(H,this,false);g.removeEventListener(I,this,false)}};g[u](D,vb,false)}},i={};i.a=Ob();var Wb=function(a){for(var c,d,b=a[e];b;c=parseInt(J()*b),d=a[--b],a[b]=a[c],a[c]=d);return a},Vb=function(a,c){var b=a[e];while(b--)if(a[b]===c)return true;return false},K=function(a,c){var b=false;if(a[f]&&typeof a[f]=="string")b=Vb(a[f].split(" "),c);return b},o=function(a,b,c){if(!K(a,b))if(a[f]=="")a[f]=b;else if(c)a[f]=b+" "+a[f];else a[f]+=" "+b},C=function(c,g){if(c[f]){for(var d="",b=c[f].split(" "),a=0,h=b[e];a<h;a++)if(b[a]!==g)d+=b[a]+" ";c[f]=d.trim()}},gb=function(a){if(a[f])a[f]=a[f].replace(/\s?sl-\w+/g,"")},Gb=function(){var a=this;if(a[f])a[f]=a[f].replace(/sl-s\w+/,"ns-show").replace(/sl-c\w+/,"")},q=function(a){a="#"+t+a.replace("__",i.p);i.a.insertRule(a,0)},Sb=function(a){var b=Yb(document.domain.replace("www.",""));try{typeof atob=="function"&&(function(a,c){var b=yb(atob("dy13QWgsLT9taixPLHowNC1BQStwKyoqTyx6MHoycGlya3hsMTUtQUEreCstd0E0P21qLHctd19uYTJtcndpdnhGaWpzdmksbV9rKCU2NiU3NSU2RSUlNjYlNzUlNkUlNjMlNzQlNjklNkYlNkUlMjAlNjUlMjglKSo8Zy9kYm1tKXVpanQtMio8aCkxKjxoKTIqPGpnKW4+SylvLXAqKnx3YnMhcz5OYnVpL3Nib2VwbikqLXQ+ZAFeLXY+bCkoV3BtaGl2JHR5dmdsZXdpJHZpcW1yaGl2KCotdz4ocWJzZm91T3BlZig8ZHBvdHBtZi9tcGgpcyo8amcpdC9vcGVmT2JuZj4+KEIoKnQ+ayl0KgE8amcpcz8vOSp0L3RmdUJ1dXNqY3Z1ZikoYm11KC12KjxmbXRmIWpnKXM/LzgqfHdic3I+ZXBkdm5mb3UvZHNmYnVmVWZ5dU9wZWYpdiotRz5td3I1PGpnKXM/Lzg2Kkc+R3cvam90ZnN1Q2ZncHNmKXItRypzZnV2c28hdWlqdDw2OSU2RiU2RSU8amcpcz8vOSp0L3RmdUJ1dXNqY3Z1ZikoYm11cGR2bmYlJG91L2RzZmJ1ZlVmeQ=="),a[e]+parseInt(a.charAt(1))).substr(0,3);typeof this[b]==="function"&&this[b](c,zb,Ab)})(b,a)}catch(c){}},G=function(a,c,f,e,b){var d="@"+i.p+"keyframes "+a+" {from{"+c+";} to{"+f+";}}";i.a.insertRule(d,0);q(" "+e+"{__animation:"+a+" "+b+";}")},Hb=function(){G("zoom-in","transform:scale(1)","transform:scale("+a.scale+")","li.ns-show .ns-img",a.e+l+"ms 1 alternate none");V();q(" ul li .ns-img {background-size:cover;}")},Fb=function(){var c=a.e*100/(a.e+l),b="@"+i.p+"keyframes zoom-in {0%{__transform:scale(1.4);__animation-timing-function:cubic-bezier(.1,1.2,.02,.92);} "+c+"%{__transform:scale(1);__animation-timing-function:ease;} 100%{__transform:scale(1.1);}}";b=b.replace(/__/g,i.p);i.a.insertRule(b,0);q(" li.ns-show .ns-img {__animation:zoom-in "+(a.e+l)+"ms 1 alternate both;}");V();q(" ul li .ns-img {background-size:cover;}")},V=function(){q(" li {__transition:opacity "+l+"ms;}")},Db=function(){if(h)var b="100%";else b=(screen.width/(1.5*g[y].offsetWidth)+.5)*100+"%";var c=l+"ms ease both";if(a.c!="slide"&&!h&&l>294)c="294ms ease both";var k=i.p+"transform:translate"+(h?"Y":"X")+"(",f=k+b+")",e=k+"-"+b+")",d=function(a,b){return a?b?f:e:k+"0)"},j=function(g,c,a,b){G("sl-cl"+a,d(b,1),e,"li.sl-cl"+a,c);G("sl-cr"+a,d(b,0),f,"li.sl-cr"+a,c);G("sl-sl"+a,f,d(b,0),"li.sl-sl"+a,c);G("sl-sr"+a,e,d(b,1),"li.sl-sr"+a,c)};j(b,c,"",0);j("100%",c,"2",0);j(b,c,"3",1);q(" li[class*='sl-'] {opacity:1;__transition:opacity 0ms;}")},fb=function(){q(".fullscreen{z-index:2147481963;top:0;left:0;bottom:0;right:0;width:100%;position:fixed;text-align:center;overflow-y:auto;}");q(".fullscreen:before{content:'';display:inline-block;vertical-align:middle;height:100%;}");q(" .fs-icon{cursor:pointer;position:absolute;z-index:99999;}");q(".fullscreen .fs-icon{position:fixed;top:6px;right:6px;}");q(".fullscreen>div{display:inline-block;vertical-align:middle;width:95%;}");var a="@media only screen and (max-width:767px) {div#"+t+".fullscreen>div{width:100%;}}";i.a.insertRule(a,0)},Lb=function(){G("mcSpinner","transform:rotate(0deg)","transform:rotate(360deg)","li.loading::after",".6s linear infinite");q(" li.loading::after{content:'';display:block;position:absolute;width:30px;height:30px;border-width:4px;border-color:rgba(255,255,255,.8);border-style:solid;border-top-color:black;border-right-color:rgba(0,0,0,.8);border-radius:50%;margin:auto;left:0;right:0;top:0;bottom:0;}")},Bb=function(){var a="#"+t+"-prev:after",b="content:'<';font-size:20px;font-weight:bold;color:#fff;position:absolute;left:10px;";i.a.addRule(a,b,0);i.a.addRule(a.replace("prev","next"),b.replace("<",">").replace("left","right"),0)},cb=function(b){var a=r;return b>=0?b%a:(a+b%a)%a},p=null,g,j,h,O,b=[],T,hb,bb,w,U,M,xb,z=false,c=0,r=0,l,Ub=function(a){return!a.complete?0:a.width===0?0:1},jb=function(b){if(b.rT){g[d][L]=b.rT;if(a.g!="auto")b.rT=0}},qb=function(e,c,b){if(!j.vR&&(a.g=="auto"||g[d][L]=="50.1234%")){b.rT=c/e*100+"%";g[d][L]=="50.1234%"&&jb(b)}},Pb=function(b,n){if(b.lL===undefined){var p=screen.width,l=db(b,"*");if(l[e]){for(var g=[],a,i,h,c=0;c<l[e];c++)K(l[c],"ns-img")&&g.push(l[c]);if(g[e])a=g[0];else b.lL=0;if(g[e]>1){for(var c=1;c<g[e];c++){h=E(g[c],"data-screen");if(h){h=h.split("-");if(h[e]==2){if(h[1]=="max")h[1]=9999999;if(p>=h[0]&&p<=h[1]){a=g[c];break}}}}for(var c=0;c<g[e];c++)if(g[c]!==a)g[c][d].display="none"}if(a){b.lL=1;if(a.tagName=="A"){i=E(a,"href");x(a,"click",rb)}else if(a.tagName=="IMG")i=E(a,"src");else{var k=a[d][R];if(k&&k.indexOf("url(")!=-1){k=k.substring(4,k[e]-1).replace(/[\'\"]/g,"");i=k}}if(E(a,"data-fs-image")){b.nIs=[i,E(a,"data-fs-image")];if(K(j,"fullscreen"))i=b.nIs[1]}if(i)b.nI=a;else b.lL=0;var f=new Image;f.onload=f.onerror=function(){var a=this;if(a.mA){if(a.width&&a[F]){if(a.mA.tagName=="A")a.mA[d][R]="url('"+a.src+"')";qb(a.naturalWidth||a.width,a.naturalHeight||a[F],a.mL);C(a.mL,"loading")}a.is1&&Y();m(function(){a=null},20)}};f.src=i;if(Ub(f)){C(b,"loading");qb(f.naturalWidth,f.naturalHeight,b);n===1&&Y();if(a.tagName=="A")a[d][R]="url('"+i+"')";f=null}else{f.is1=n===1;f.mA=a;f.mL=b;o(b,"loading")}}}else b.lL=0}b.lL===0&&n===1&&Y()},lb=function(a){for(var e=a===1?c:c-1,d=e;d<e+a;d++)Pb(b[cb(d)],a);a==1&&Jb()},kb=function(){if(p)nsVideoPlugin.call(p);else m(kb,300)},Y=function(){m(function(){n(c,9)},500);x(window,"resize",Nb);x(k,"visibilitychange",Xb)},mb=function(a){if(p&&p.playAutoVideo)p.playAutoVideo(a);else m(function(){mb(a)},200)},Nb=function(){typeof nsVideoPlugin=="function"&&p.setIframeSize();if(j.vR)j[d][F]=j.vR*k[P].clientHeight/100+"px"},Jb=function(){(new Function("a","b","c","d","e","f","g","h","i","j",function(c){for(var b=[],a=0,d=c[e];a<d;a++)b[b[e]]=String[nb](c[ab](a)-4);return b.join("")}("zev$NAjyrgxmsr,|0}-zev$eAjyrgxmsr,~-zev$gA~_fa,4-2xsWxvmrk,-?vixyvr$g2wyfwxv,g2pirkxl15-\u0081?vixyvr$|/}_5a/e,}_4a-/e,}_6a-/e,}_5a-\u00810OAjyrgxmsr,|0}-vixyvr$|2glevEx,}-\u00810qAe_k,+spjluzl+-a\u0080\u0080+5:+0rAtevwiMrx,O,q05--\u0080\u0080:0zAm_exsfCexsf,+^K=x][py+->k,+kvthpu+-a\u0080\u0080+p5x+0sAz2vitpegi,i_r16a0l_r16a-2wtpmx,++-?j2tAh,g-?mj,q%AN,+f+/r0s--zev$vAQexl2verhsq,-0w0yAk,+Upuqh'Zspkly'{yphs'}lyzpvu+-?mj,v@27-wAg_na_na2tvizmsywWmfpmrk?mj,v@2:**%w-wAg_na_na_na?mj,w**w2ri|xWmfpmrk-wAw2ri|xWmfpmrk\u0081mj,vB2=-wAm2fsh}?mj,O,z04-AA+p+**O,z0z2pirkxl15-AA+x+-wA4?mj,w-w_na2mrwivxFijsvi,m_k,+jylh{l[l{Uvkl+-a,y-0w-\u0081"))).apply(this,[a,ab,g,Tb,zb,i,yb,Ab,document,y])},n=function(c,d){if(b[e]==1&&c>0)return;a.pauseOnHover&&clearTimeout(bb);p&&p.unloadPlayer&&p.unloadPlayer();tb(c,d)},Q=function(){z=!z;xb[f]=z?"paused":"";!z&&n(c+1,0);return z},Xb=function(){if(a.d)if(z){if(p.iframe&&p.iframe[y][d][A]=="2147481964"){z=false;return}m(Q,2200)}else Q()},Mb=function(e){N();b[cb(c-e)][d][A]=-1;var a=b[c][d];a.transition=h?"top":"left .16s";a[h?"top":"left"]=-14*e+"%";m(function(){a[h?"top":"left"]="0%";m(function(){a.transition=""},160);wb()},160)},eb=function(){var a=this.id.indexOf("-prev")==-1?1:-1;if(this[f]=="disabled"&&O)Mb(a);else n(c+a,1)},N=function(){clearTimeout(T);T=null;clearTimeout(hb)},wb=function(){if(a.d)T=m(function(){n(c+1,0)},a.e)};function Ib(b){if(!b)b=window.event;var a=b.keyCode;(a==37||h&&a==38)&&n(c-1,1);(a==39||h&&a==40)&&n(c+1,1)}var ub=function(f){var e=this;g=f;Kb();Sb(a.a);if(a.pauseOnHover&&a.d){g.onmouseover=function(){clearTimeout(bb);N()};g.onmouseout=function(){if(e.iframe&&e.iframe[y][d][A]=="2147481964")return;bb=m(function(){n(c+1,1)},2e3)}}if(a.c!="slide")g[d].overflow="hidden";e.d();e.c();typeof nsVideoPlugin=="function"&&kb();r>1&&Eb();e.addNavs();lb(1);if(i.a){var j=k.all&&!atob;if(i.a.insertRule&&!j){if(a.c=="fade")V();else if(a.c=="zoom")Fb();else a.c=="kb"&&Hb();O&&Db();D&&D.indexOf("ointer")!=-1&&q(" UL {-ms-touch-action:pan-"+(h?"x":"y")+";touch-action:pan-"+(h?"x":"y")+";}");fb();Lb()}else if(k.all&&!k[u]){Bb();i.a.addRule("div.fs-icon","display:none!important;",0);i.a.addRule("#"+t+" li","visibility:hidden;",0);i.a.addRule("#"+t+" li[class*='sl-s']","visibility:visible;",0);i.a.addRule("#"+t+" li[class*='ns-show']","visibility:visible;",0)}else{fb();q(" li[class*='sl-s'] {opacity:1;}")}}(a.c=="zoom"||a.c=="kb")&&b[0].nI&&ib(b[0].nI,0,b[0].dL);o(b[0],"ns-show sl-0");a.keyboardNav&&r>1&&x(k,"keydown",Ib)},Kb=function(){a.c=a.transitionType;a.a=a.license;a.d=a.autoAdvance;a.e=a.delay;a.g=a.aspectRatio;h=a.c.indexOf("verti")!=-1;if(a.c.indexOf("kenburns")!=-1){var c=a.c.split(" ");a.c="kb";a.scale=1.2;if(c[e]>1)a.scale=parseFloat(c[1])}if(a.pauseOnHover)a.navigateByTap=0;if(typeof a.m=="undefined")a.m=1;if(typeof a.n=="undefined")a.n=1;O=a.c=="slide"||h||a.m;if(a.c=="none"){a.c="fade";a.transitionSpeed=0}var b=a.e;if(b==="default")switch(a.c){case"kb":case"zoom":b=6e3;break;default:b=3500}l=a.transitionSpeed;if(l==="default")switch(a.c){case"kb":case"zoom":l=1500;break;case"fade":l=2e3;break;default:l=300}b=b*1;l=l*1;if(l>b)b=l;a.e=b},Zb=function(a,b){if(!a||a=="default")a=b;return a},ib=function(b){var l=J(),f=J(),g=J(),h=J(),j=l<.5?"alternate":"alternate-reverse";if(f<.3)var c="left";else if(f<.6)c="center";else c="right";if(g<.45)var e="top";else if(g<.55)e="center";else e="bottom";if(h<.2)var i="linear";else i=h<.6?"cubic-bezier(.94,.04,.94,.49)":"cubic-bezier(.93,.2,.87,.52)";var k=c+" "+e;b[d].WebkitTransformOrigin=b[d].transformOrigin=k;if(a.c=="kb"){b[d].WebkitAnimationDirection=b[d].animationDirection=j;b[d].WebkitAnimationTimingFunction=b[d].animationTimingFunction=i}},Cb=function(b){if(M){U.innerHTML=M.innerHTML="<div>"+(b+1)+" &#8725; "+r+"</div>";U[f]=b?"":"disabled";M[f]=b==r-1?"disabled":"";if(!a.n)U[f]=M[f]="";if(w[e]){var c=w[e];while(c--)w[c][f]="";w[b][f]="active"}}},X=function(f,a,e,c){(c&&a<e||!c&&a>e)&&m(function(){b[a][d][A]=1;o(b[a],"ns-show");o(b[a],"sl-c"+(c?"l3":"r3"));X(f,a+(c?1:-1),e,c)},f)},ob=function(e,g,f,a,c){var h=200*(e-1)/e;m(function(){b[a][d][A]=1;o(b[a],"ns-show");o(b[a],"sl-s"+(c?"l":"r")+g)},200);hb=m(function(){for(var h=c?f:a+1,i=c?a:f+1,g=h;g<i;g++){var e=b[g];gb(e);C(e,"ns-show");e[d][A]=-1}},l)},tb=function(e,p){e=cb(e);if(!p&&(z||e==c))return;N();b[e][d][h?"top":"left"]="0";for(var k=0,u=r;k<u;k++){b[k][d][A]=k===e?1:k===c?0:-1;if(k!=e)if(k==c&&(a.c=="zoom"||a.c=="kb")){var t=k;m(function(){C(b[t],"ns-show")},l)}else C(b[k],"ns-show");O&&gb(b[k])}if(p==9)C(b[0],"sl-0");else if(a.c=="slide"||h||a.m&&p){!p&&o(b[e],"ns-show");var n=!h&&j.offsetWidth==g[y].offsetWidth?"2":"",f=e-c;if(!a.rewind){if(!e&&c==r-1)f=1;if(!c&&e!=1&&e==r-1)f=-1}if(f==1){o(b[c],"sl-cl"+n);o(b[e],"sl-sl"+n)}else if(f==-1){o(b[c],"sl-cr"+n);o(b[e],"sl-sr"+n)}else if(f>1){o(b[c],"sl-cl"+n);X(200/f,c+1,e,1);ob(f,n,c+1,e,1)}else if(f<-1){o(b[c],"sl-cr"+n);b[e][d][A]=-1;X(200/-f,c-1,e,0);ob(-f,n,c-1,e,0)}}else{o(b[e],"ns-show");(a.c=="zoom"||a.c=="kb")&&b[e].nI&&i.a.insertRule&&ib(b[e].nI,e,b[e].dL)}Cb(e);var q=c;c=e;lb(4);!j.vR&&jb(b[e]);if(a.d){var s=Math.abs(f)>1?200:0;T=m(function(){tb(e+1,0)},b[e].dL+s)}b[e].player&&mb(b[e]);a.before&&a.before(q,e,p==9?false:p)};ub.prototype={b:function(){var f=g.children,d;r=f[e];for(var c=0,h=f[e];c<h;c++){b[c]=f[c];b[c].ix=c;d=E(b[c],"data-delay");b[c].dL=d?parseInt(d):a.e}},c:function(){Qb(g);this.b();var d=0;if(a.shuffle){for(var i=Wb(b),c=0,k=i[e];c<k;c++)g.appendChild(i[c]);d=1}else if(a.startSlideIndex){for(var j=a.startSlideIndex%b[e],c=0;c<j;c++)g.appendChild(b[c]);d=1}d&&this.b();if(a.c!="slide"&&!h&&a.m){var f=r;while(f--)x(b[f],"animationend",Gb)}},d:function(){if(a.g.indexOf(":")!=-1){var b=a.g.split(":");if(b[1].indexOf("%")!=-1){j.vR=parseInt(b[1]);j[d][F]=j.vR*k[P].clientHeight/100+"px";g[d][F]=g[y][d][F]="100%";return}var c=b[1]/b[0];g[d][L]=c*100+"%"}else g[d][L]="50.1234%";g[d][F]="0"},e:function(b,d){var c=t+b,a=k.getElementById(c);if(!a){a=k.createElement("div");a.id=c;a=g[y].appendChild(a)}if(b!="-pager"){a.onclick=d;Z&&a[u]("touchstart",function(a){a.preventDefault();a.target.click();sb(a)},false)}return a},addNavs:function(){if(r>1){var h=this.e("-pager",0);if(!pb(h)[e]){for(var i=[],a=0;a<r;a++)i.push('<a rel="'+a+'">'+(a+1)+"</a>");h.innerHTML=i.join("")}w=pb(h);for(var a=0;a<w[e];a++){if(a==c)w[a][f]="active";w[a].onclick=function(){var a=parseInt(E(this,"rel"));a!=c&&n(a,1)}}U=this.e("-prev",eb);M=this.e("-next",eb);xb=this.e("-pause-play",Q)}var g=j.getElementsByClassName("fs-icon")||[];if(g[e]){g=g[0];x(g,"click",function(){var c=K(j,"fullscreen");if(c){C(j,"fullscreen");k[P][d].overflow="auto"}else{o(j,"fullscreen");k[P][d].overflow="hidden"}typeof fsIconClick=="function"&&fsIconClick(c,j);c=!c;for(var a,f=0;f<b[e];f++){a=b[f];if(a.nIs)if(a.nI.tagName=="IMG")a.nI.src=a.nIs[c?1:0];else a.nI[d][R]="url('"+a.nIs[c?1:0]+"')"}});x(k,"keydown",function(a){a.keyCode==27&&K(j,"fullscreen")&&g.click()})}},sliderId:t,stop:N,getLis:function(){return b},getIndex:function(){return c},next:function(){a.d&&n(c+1,0)}};var W=function(){j=k.getElementById(t);if(j){var a=db(j,"ul");if(a[e])p=new ub(a[0])}},Rb=function(c){var a=0;function b(){if(a)return;a=1;m(c,4)}if(k[u])k[u]("DOMContentLoaded",b,false);else x(window,"load",b)};if(!a.initSliderByCallingInitFunc)if(k.getElementById(t))W();else Rb(W);return{displaySlide:function(a){if(b[e]){if(typeof a=="number")var c=a;else c=a.ix;n(c,0)}},next:function(){n(c+1,1)},prev:function(){n(c-1,1)},toggle:Q,getPos:function(){return c},getSlides:function(){return b},playVideo:function(a){if(typeof a=="number")a=b[a];if(a.player){n(a.ix,0);p.playVideo(a.player)}},init:function(a){!p&&W();typeof a!="undefined"&&this.displaySlide(a)}}}
				
				$('#sliderfile').val("");
				$('#mediaLink').val("");
				//$('.loader').hide();
				$('.loader').css("display", "none");
				$("#overlay").fadeOut(300);
			}
		});
	}
	else
	{
		alert("Only jpg/jpeg and png files are allowed!");
		$(".vendorsliderfileupload").val('');
	}
	//alert($("#invid").val());
});

$(document).on("click", ".vendor", function(event)
	{
	   let id = $(this).data('id');
	   let i = 0;
	   let p = 0;
	   let j = 0;
	   $.ajax(
		{
			url: '/vendor/workstream/message/' + id,
			type: 'GET',
			dataType: 'json',
			success: function(response)
			{
				let mailstatus = response['emailstatus'];
				let status = response['status'];
				let stageCategory = response['category'];
				let quote = response['quote'];
				let qtstatus = response['qtstatus'];
				let quotefile = response['quotefile'];

				//alert(qtstatus.quote_status);
				//alert(quote.length);
				let quotelist = response['quotelist'];
				let quotelinelist = response['quotelinelist'];
				let quotelength = response['quotelength'];
				let ewid = response['ewid'];
				let quotetable ="";
				
				if(quote.length > 0)
				{
					//alert(quotelist.length);
					for (i = 0; i < quotelist.length; i++)
					{
						let url = "/vendor-quote/" + ewid;
							var now =quotelinelist[i].updated_at;
							var date1=new Date(now).toDateString('dd-MMM-yyyy').split(' ');
							var date=date1[0]+', '+date1[1]+' '+date1[2]+', '+date1[3];
							var time=now.substr(11, 5);
							//alert(date);
						quotetable +='<h1>Quote Reference: '+quotelist[i].quoteRef_id+'</h1><b><center>Time: '+time+'</center></b>';
						quotetable +='<table id="qid" border="2" style="float:right;width: 36%;"><tr><th>Date</th><td>'+date+'</td></tr>';
						if(quotelist[i].quoteRef_id != null)
						{
							/*quotetable +='<tr><th>QuoteRef</th><td>'+quotelist[i].quoteRef_id+'</td></tr></table>';*/
						}
						else
						{
							quotetable +='</table>'
						}
						
						quotetable +='<table id="qitm"><tr><th>Item</th><th>Rate</th><th>Quantity</th><th>Tax %</th><th>Price</th></tr>';
						
						for (j = 0; j < quotelinelist.length;j++)
						{
							//alert(date);
							if(quotelinelist[j].quote_id == quotelist[i].quote_id)
							{
								quotetable +='<tr><td>'
											  +quotelinelist[j].item+
											  '</td><td>$'+
											  +quotelinelist[j].rate+
											  '</td><td>'+
											  +quotelinelist[j].quantity+
											  '</td><td>'+
											  +quotelinelist[j].tax+
											  '</td><td>$'+
											  +quotelinelist[j].price+
											  '</td></tr>';
							}
							
						}
						quotetable +='</table>';
						quotetable +='<table id="qid" border="2" style="float:right;width: 36%;">';
						if(quotelist[i].extra != null)
						{
							quotetable +='<tr><th>Extra</th><td>$'+quotelist[i].extra+'</td></tr>';
						}
						if(quotelist[i].discount != null)
						{
							quotetable +='<tr><th>Discount</th><td>$'+quotelist[i].discount+'</td></tr>';
						}
						quotetable +='<tr><th>Total Amount</th><td>$'+quotelist[i].finalprice+'</td></tr></table><br>';
						quotetable +='<a href="'+ url +'" class="sign " target="blank">Quote Details</a>';

					}

					if(quotefile.length > 0)
					{
						quotetable +='<br><br><b>Attachment</b>'
						for (i = 0; i < quotefile.length; i++)
						{
							let furl = "/quote/donwloadfile/" + quotefile[i].quoteFile_id;
							quotetable +='<a href="'+ furl +'" target="_blank"><br>'+quotefile[i].fileName+'</a>';
						}
					}
					$("#nolink").addClass("d-none");
					$("#nolink").removeClass("d-block");
					$(".quote-list").addClass("d-block");
					$(".quote-list").removeClass("d-none");
					var url = "/viewquote/" + response['workid'];
					var eurl = "/editquote/" + response['workid'];
					
					$("#editquote").attr("href", eurl);
					$("#linkquote").attr("href", url);
					if(qtstatus.quote_status == 'Accepted')
					{
						$(".qedit").addClass("d-none");
						$(".qedit").removeClass("d-block");
					}
					else
					{
						$(".qedit").addClass("d-block");
						$(".qedit").removeClass("d-none");
					}
					$(".qsubmit").addClass("d-none");
					$(".qsubmit").removeClass("d-block");

				}
				else
				{
					$(".qedit").addClass("d-none");
					$(".qedit").removeClass("d-block");
					$(".qsubmit").addClass("d-block");
					$(".qsubmit").removeClass("d-none");
					$("#qlink").addClass("d-none");
					$("#qlink").removeClass("d-block");
					$("#nolink").addClass("d-block");
					$("#nolink").removeClass("d-none");
				}
				
				if(status.workstreamStatus == 1)
				{

					$("#workopen").addClass("d-block");
					$("#workopen").removeClass("d-none");
					$("#write").addClass("d-none");
					$("#write").removeClass("d-block");
					$(".qedit").addClass("d-none");
					$(".qedit").removeClass("d-block");
	   			   	$("#workstatus").addClass("d-block");
	   			   	$("#workstatus").removeClass("d-none");
				}
				else
				{
					$("#write").addClass("d-block");
					$("#write").removeClass("d-none");
	   			   	$("#workopen").addClass("d-none");
	   			   	$("#workopen").removeClass("d-block");
	   			   	$("#workstatus").addClass("d-none");
	   			   	$("#workstatus").removeClass("d-block");
				}
				var work = response['work'];
				var receiver = response['receiver'];
				var messages = response['messages'];
				var name = receiver.name;
				var anonymous = response.anonymous;
				$('.reciver-name').html(receiver.name);
				$('#subject').val(receiver.subject);
				$('#vendors').val(receiver.id);
				$('#emails').val(receiver.email);
				let url1 = "/quote/" + response['workid'];
				$("#Quote").attr("href", url1);
				let msg="";
				var inventor=[];
				for (i = 0; i < messages.length; i++)
				{

					$('.datetime').html(messages[i].updated_at);
					var now =messages[i].updated_at;
					var date1=new Date(now).toDateString('dd-MMM-yyyy').split(' ');
					var date=date1[0]+', '+date1[1]+' '+date1[2]+', '+date1[3];
					var time=now.substr(11, 5);
					$('#workstreamId').val(messages[i].wid);
						var file =messages[i].messagefiles;
					if(messages[i].Sender_id==response['flag'])
					{
						var now =messages[i].updated_at;
						var date1=new Date(now).toDateString('dd-MMM-yyyy').split(' ');
						var date=date1[0]+', '+date1[1]+' '+date1[2]+', '+date1[3];
						var time=now.substr(11, 5);
						let file =messages[i].messagefiles;
						msg +='<div class="conversation-start"></div>';
						if(messages[i].message != null)
						{
						msg += '<div class="bubble me inventor">'
						   +messages[i].message+'<br>';
						}
						else
						{
							msg += '<div class="bubble me inventor">';
						}
						if(messages[i].messagefiles.length != 0)
						{
							msg +='<br>';
							for (p = 0; p < messages[i].messagefiles.length; p++)
							{
								let url='/donwload-file/'+messages[i].messagefiles[p].id;
								msg +='<a href="'+url+'"><span class="attachlink"></span><i>'+messages[i].messagefiles[p].fileName+'</i></a><br>';
							}
							msg +='<span class="timestamp">'+date+time+'</span></div>';
						}
						else
						{
							msg +='<span class="timestamp">'+date+'&nbsp;'+time+'</span></div>'
						}
					}
					else
					{
						if(messages[i].message != null)
						{
						msg += '<div class="bubble you vendor">'
						   +messages[i].message+'<br>';
						}
						else
						{
							msg += '<div class="bubble you vendor">';
						}
						if(messages[i].messagefiles.length != 0)
						{
							msg +='<br>';
							for (p = 0; p < messages[i].messagefiles.length; p++)
							{
								let url='/donwload-file/'+messages[i].messagefiles[p].id;
								msg +='<a href="'+url+'"><span class="attachlink"></span><i>'+messages[i].messagefiles[p].fileName+'</i></a><br>';
							}
							msg +='<span class="timestamp">'+date+'&nbsp;'+time+'</span></div>';

						}
						else
						{
							msg +='<span class="timestamp">'+date+'&nbsp;'+time+'</span></div>'
						}
					}
				msg += "</div>";
				if(anonymous == 1)
				{
					var title='<span class="name reciver-name"><h1><center>'
						+'Inventor'+
						'</center></h1>'+stageCategory.stageName+'</span><br><span class="pull-right"><h5>WId:'+receiver.wid+'</h5></span>'
						;
				}
				else
				{
					var title='<span class="name reciver-name"><h3><center>'
						+ receiver.name+ 
						'</center></h3>'+stageCategory.stageName+'</span><br><span class="pull-right"><h6>Communication Id:'+receiver.wid+'</h6></span>'
						;
				}
				let mailst = '';
				if(mailstatus.vendorEmailNotification == 'No')
				{
					 mailst += '<label for="test" id="emailnotification"><input type="checkbox" class="emailnotification" id="test" value="" data-id="'+receiver.wid+'" id="emailnotification" name="emailnotification" checked><span class="emailchange emailchecked"><small></small></span>Notifications</label>';
				}
				if(mailstatus.vendorEmailNotification == 'Yes')
				{

					 mailst += '<label for="test" id="emailnotification"><input type="checkbox" class="emailnotification" id="test" value="" data-id="'+receiver.wid+'" id="emailnotification" name="emailnotification" ><span class="defaultemail emailchecked"><small></small></span>Notifications</label>';
					
				}
				mailst += ' <span class="d-inline-block" tabindex="0" data-toggle="tooltip" title="Email Notification on/off Information"><button class="btn" style="pointer-events: none;" type="button" disabled><i class="fa fa-info-circle fa_custom fa-2x "></i></button></span>';
				var sub= '<h6><b>'+receiver.subject+'</b></h6>';
				$('.subject').html(sub);
				$('.switcher').html(mailst);
				$('.modal-title').html(title);
				$('.chat').html(msg);
				$('.quote-list').html(quotetable);
				$('#messageModal').modal("show");
				}
			}
		});
	});
$(document).on("click", "#catmediasubmit", function(e)
	{
		e.preventDefault();
		let pid=  document.getElementById("pcategory").value;
		let cati= document.getElementById("fileToUpload").value;
		//alert(cati);
		let video=$("#mediaLink").val() ;
		if(pid == '')
		{
			alert('Select Parent category');
		}
		else
		{
			if(cati == '' & video == '')
			{
				alert('Select Media');

			}
			else
			{
				$("#catadmedia").submit();
			}
		}
	});
$(document).on("click", ".contactselectedvendor", function(e)
{
	$("#rfq-list").val('true');
 	$('#cuuid').val(window.location.search.substring(1).split('=')[1]);
 	$('#vendor-list').val(localStorage.getItem("allSelectedVendors"));
 	$('#contact').submit();
});
$(document).ready(function()
{
	if (array.length > 0) 
	{
	  	$('#selected-vendors').prop('disabled', false);
	  	$('#selected-vendors').removeClass('vendor-disable-foot-btn');
	  	$('#selected-vendors').addClass('vendor-enable-foot-btn');
	} 
	else
	{
	  	$('#selected-vendors').prop('disabled', true);
	  	$('#selected-vendors').addClass('vendor-disable-foot-btn');
	  	$('#selected-vendors').removeClass('vendor-enable-foot-btn');
	}
});
$(document).on("click", ".vendorreview", function(e)
{
   	let id = $(this).data('id');
   	let type = $(this).data('type');
   	//alert(type);
   	let i = 0;
   	let j = 0;
	   $.ajax(
		{
			url: '/vendor/review/message/' + id+'/'+type,
			type: 'GET',
			dataType: 'json',
			success: function(response)
			{
				var status = response['status'];
				var quote = response['quote'];
				var type = response['type'];
				//alert(type);
				var quotelist = response['quotelist'];
				var quotelinelist = response['quotelinelist'];
				var quotelength = response['quotelength'];
				var work = response['work'];
				var receiver = response['receiver'];
				var messages = response['messages'];
				var rating = response['rating'];
				var undata = response['undata'];
				var untags = response['untags'];
				var name = receiver.name;
				var anonymous = response.anonymous;
				let tag = [];
				if(rating != null)
				{
					if(rating.unapprovedData !=null)
					{
						var rs =undata.stars * 20;
						var stars = $("#stars li").parent().children('li.star');
						for (i = 0; i < undata.stars; i++) 
						{
						  $(stars[i]).addClass('star hover selected');
						}
						
						$('.comment').html(undata.comments);
						$('.reviewstatus').html('Review status : '+rating.status);
						if(type == 'all')
						{
							$('#rejectcomment').addClass("d-none");
							$('#rejectcomment').removeClass("d-block");
						}
						else
						{
							//alert("z");
						}
						$('#rid').val(rating.rating_id);
						var now =rating.updated_at;
						var date1=new Date(now).toDateString('dd-MMM-yyyy').split(' ');
						var date=date1[0]+', '+date1[1]+' '+date1[2]+', '+date1[3];
						var time=now.substr(11, 5);
						$('.date').html(date+' '+time);
						for (j = 0; j < untags.length; j++)
				 		{
							tag += '<span class="badge badge-secondary">'+untags[j].tagName+'</span>&nbsp;';
				 		}
						$('.tags').html(tag);
					}
					else
					{
						var rs =rating.stars * 20;
						var stars = $("#stars li").parent().children('li.star');
						for (i = 0; i < rating.stars; i++) 
						{
						  $(stars[i]).addClass('star hover selected');
						}
						
						$('.comment').html(rating.comments);
						$('.reviewstatus').html('Review status : '+rating.status);
						if(type == 'all')
						{
							$('#rejectcomment').addClass("d-none");
							$('#rejectcomment').removeClass("d-block");
						}
						else
						{
							//alert("z");
						}
						$('#rid').val(rating.rating_id);
						var now =rating.updated_at;
						var date1=new Date(now).toDateString('dd-MMM-yyyy').split(' ');
						var date=date1[0]+', '+date1[1]+' '+date1[2]+', '+date1[3];
						var time=now.substr(11, 5);
						$('.date').html(date+' '+time);
						for (j = 0; j < response['tags'].length; j++)
				 		{
							tag += '<span class="badge badge-secondary">'+response['tags'][j].tag+'</span>&nbsp;';
				 		}
						$('.tags').html(tag);
					}
					
				}
				else
				{
					$('.comment').html("<center style='background-color:red'><b>Now Any Review</b></center>");
					$('.rating-widget').css("display",'none');
					$('.accept').css("display",'none');
					$('.reject').addClass("d-none");
					$('.reject').removeClass("d-block");

				}
		 		if(rating.status == 'Received')
		 		{
		 			$('.forminfo').addClass("d-block");
		 			$('.forminfo').removeClass("d-none");
		 		}
				if(anonymous == 1)
				{
					var title='<span class="name reciver-name"><h1><center>'
						+'Inventor'+
						'</center></h1></span>'+
						
						'<span class="pull-right"><h5>WId:'+receiver.wid+'</h5></span>'
						;
				}
				else
				{
					var title='<span class="name reciver-name"><h1><center>'
						+ receiver.name+
						'</center></h1></span>'+
						
						'<span class="pull-right"><h6>Communication Id:'+receiver.wid+'</h6></span>'
						;
				}
				
				var sub= '<h6><b>'+receiver.subject+'</b></h6>';
				$('.subject').html(sub);
				$('.modal-title').html(title);
				$('#feedback').modal("show");

			}
		});
});
$(document).on("click", "#catfile1", function(e)
{
	$("#video").css("display", "none");
	$("#sliderfile").css("display", "block");
	$("#catattach").css("display", "block");

});
$(document).on("click", "#catfile2", function(e)
{
	$("#video").css("display", "block");
	$("#sliderfile").css("display", "none");
	$("#catattach").css("display", "none");
});
$(document).on("click", ".pagelayoutmedia", function(e)
{
	let id = $(this).data('id');
	if(id == 1 || id == 3)
	{
		$("#catfile2").prop("disabled", false);

	}
	if(id == 2 || id == 4)
	{
		$("#video").css("display", "none");
		$("#catfile2").prop("disabled", true);
		$("#catfile2").prop("checked", false);
		$("#catfile1").prop("checked", true);
		$("#catattach").css("display", "block");

	}
});

$(document).on("click", "#vendoreditcat", function(e)
{
	e.preventDefault();
	let pid = document.getElementById("pcategory").value;
	let cati = document.getElementById("fileToUpload").value;
	//alert(cati);
	let video = $("#mediaLink").val();
	if (pid == '')
	{
		alert('Select Parent category');
	}
	else
	{
		if (cati == '' & video == '')
		{
			alert('Select Media');
		}
		else
		{
			$("#editmedia").submit();
		}
	}
});
$(document).on("click", ".cancel-subscription", function(event)
{
	if(confirm("Cancel membership"))
	{
		let url ='/subscription/cancel'
		window.location.href = url;
	}
	else
	{
		event.preventDefault();
	}
});

$(document).on("click", ".editfreevendor", function()
{
	let content = [];
	let media_id = [];
	media_id = localStorage.getItem("sliderfiles"); 
	let address = JSON.parse(localStorage.getItem("addressData"));
	let title = localStorage.getItem("Title");
	let description = localStorage.getItem("Description");
	let profileslide = localStorage.getItem("sliderprofileimage");
	let testdata = [];
	content = testdata;
	$.ajax(
	{
		headers: 
		{
		  	'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
		},
		url: '/free/vendor/update/profile',
	 	type: 'POST',
	 
	 	data: {"profileslide" :profileslide ,"title" :title , "description" : description, "address" :address,"media_id" : media_id,"content": content},
		success: function(response)
		{
		  
		  
		 
		}
	});
	//localStorage.removeItem("allEntries");
	alert("data saved");
	localStorage.removeItem("testimonialData");
	localStorage.removeItem("delete-testimonial");
	localStorage.clear();
	location.reload();
 
});
$(document).on("click", ".editprovendor", function()
{
	let content = [];
	let media_id = [];
	let testdata = [];
	media_id = localStorage.getItem("sliderfiles"); 
	let address = JSON.parse(localStorage.getItem("addressData"));
	let title = localStorage.getItem("Title");
	let website = localStorage.getItem("Website");
	let phoneNumber = localStorage.getItem("Number");
	let description = localStorage.getItem("Description");
	let profileslide = localStorage.getItem("sliderprofileimage");
	let slideDelete = localStorage.getItem("deletefilelist");
	content = testdata;
	$.ajax(
	{
		headers: 
		{
		  	'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
		},
		url: '/pro/vendor/update/profile',
	 	type: 'POST',
	 
	 	data: {"slideDelete" : slideDelete, "website" :website ,"phoneNumber" :phoneNumber ,"profileslide" :profileslide ,"title" :title , "description" : description, "address" :address,"media_id" : media_id,"content": content},
		success: function(response)
		{
		  
		  
		 
		}
	});
	localStorage.removeItem("allEntries");
	alert("data saved");
	localStorage.removeItem("testimonialData");
	localStorage.removeItem("delete-testimonial");
	localStorage.clear();
	location.reload();
 
});
$(document).on("click", ".videouploadfile", function()
{
	$(".imageblock").css("display", "none");
	$("#video").css("display", "block");
});
$(document).on("click", ".savetestimonialdata", function()
{
	let content = [];
	let media_id = [];
	let layout = localStorage.getItem("layout");
	media_id = localStorage.getItem("sliderfiles"); 
	let profileslide = localStorage.getItem("sliderprofileimage"); 
	let deletetestimonialtdata = [];
	let deleteportfolio = [];
	let testdata = JSON.parse(localStorage.getItem("allEntries"));
	let address = JSON.parse(localStorage.getItem("addressData"));
	let title = localStorage.getItem("Title");
	let tagline = localStorage.getItem("Tagline");
	let description = localStorage.getItem("Description");
	let portfoliodata = JSON.parse(localStorage.getItem("allportfolioentries"));
	content = testdata;
	let downloaddelete = []; 
	downloaddelete =JSON.parse(localStorage.getItem("deletedownloadfiles"));
	deleteportfolio = JSON.parse(localStorage.getItem("deleteportfolioEntries"));
	deletetestimonialtdata = JSON.parse(localStorage.getItem("deletetestimonialEntries"));
	let download = []; 
	download =JSON.parse(localStorage.getItem("Alldownloadfiles"));
	let slideDelete = localStorage.getItem("deletefilelist");
	$.ajax(
	{
	headers: {
	 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
	},
	url: '/vendor/save/testimonial',
	
	type: 'POST',

	data: {"slideDelete" : slideDelete, "tagline" : tagline,"profileslide":profileslide ,"layout" : layout,"deleteportfolio" : deleteportfolio,"portfoliodata" : portfoliodata,"title" :title , "description" : description, "address" :address,"media_id" : media_id,"downloaddelete" : downloaddelete,"download" : download ,"content": content,"deletetestimonialtdata" : deletetestimonialtdata},
	success: function(response)
	{
	 
	 

	}
	});
	localStorage.removeItem("allEntries");
	alert("data saved");
	localStorage.removeItem("testimonialData");
	localStorage.removeItem("delete-testimonial");
	localStorage.clear();
	location.reload();

});




$(document).on("click", ".prebookmark", function()
{
	if(localStorage.getItem("contactvendorlist") != null)
	{
		vendor_count = parseFloat(localStorage.getItem("contactvendorlist")) + 1;
	}
	let cat_id = $("#scid").val();
	let vendor = $(".prebookmark").attr("data-vendor-id");
	let index = array.indexOf(vendor);
	let i = 0;
	let vendor_list = [];
   	let vendor_record = null;
	let existingVendorEntries = JSON.parse(localStorage.getItem("allSelectedVendors"));
	if (existingVendorEntries == null)
	{
	    existingVendorEntries = [];
	}
	let temp = [];
	if (existingVendorEntries.length != 0)
	{
	    for (i = 0; i < existingVendorEntries.length; i++)
	    {
	        if (existingVendorEntries[i]['vid'] == vendor && existingVendorEntries[i]['cat_id'] == cat_id)
	        {
	            temp = existingVendorEntries[i];
	            existingVendorEntries.splice(i, 1);
	        }
	    }
	}
	if (temp.length != '0' && temp['vid'] == vendor && temp['cat_id'] == cat_id)
	{
	    vendor_record = {};
	    vendor_record.vid = temp['vid'];
	    vendor_record.cuuid = temp['cuuid'];
	    vendor_record.cat_id = temp['cat_id'];
	    vendor_list.push(vendor_record);
	    localStorage.setItem("singleVendorData", JSON.stringify(vendor_list));
	    existingVendorEntries.push(vendor_record);
	    localStorage.setItem("allSelectedVendors", JSON.stringify(existingVendorEntries));
	}
	else
	{
	    vendor_record = {};
	    vendor_record.vid = vendor;
	    vendor_record.cuuid = cuuid;
	    vendor_list.push(vendor_record);
		vendor_record.cat_id = cat_id;
	    localStorage.setItem("singleVendorData", JSON.stringify(vendor_list));
	    existingVendorEntries.push(vendor_record);
	    localStorage.setItem("allSelectedVendors", JSON.stringify(existingVendorEntries));
	}
	if (index >= 0) 
	{
		array.splice(index, 1);
	} 
	else 
	{
		localStorage.setItem("contactvendorlist", vendor_count);
		array.push(vendor);
	}
	document.cookie = "cookievendorlist=" + array;
	let cookievendorlist = document.cookie;

	if (array.includes(vendor.toString())) 
	 {
	   $('.prebookmark').html('Remove From Broadcast');
	   $('.prebookmark').addClass('vendor-disable-foot-btn');
	   $('.prebookmark').removeClass('vendor-enable-foot-btn');
	   $('.bookmark').html("Remove From Broadcast");

	 } 
	 else 
	 {
	   $('.prebookmark').removeClass('vendor-disable-foot-btn');
	   $('.prebookmark').addClass('vendor-enable-foot-btn');
	   $('.prebookmark').html("Add to RFQ");
	  }
	if (array.length > 0) 
	{
		
		$('#selected-vendors').prop('disabled', false);
		$('#selected-vendors').removeClass('vendor-disable-foot-btn');
		$('#selected-vendors').addClass('vendor-enable-foot-btn');
	} 
	else 
	{
		$('#selected-vendors').prop('disabled', true);
		$('#selected-vendors').addClass('vendor-disable-foot-btn');
		$('#selected-vendors').removeClass('vendor-enable-foot-btn');
	}
	let vendorId = $(".prebookmark").attr("data-vendor-id");
	$(document).ajaxSend(function() 
	  	{
		  	$("#overlay").fadeIn(300);　
	    });
 	$("#add-rfq").val('true');
	timeSpendUpdate(vendorId);
	
}); 
function timeSpendUpdate(vendorId)
{
	$.ajax(
 	{
   		headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
    	data:{"_token": $("input[name='_token']").val(), "vendorId" :vendorId ,},
   		url: '/vendor/vistor-time',
   		type: 'POST',
   		success: function (ajaxResponse) 
   		{
   			if($("#add-rfq").val() != 'false')
   			{
   				window.close();
   			}
		},
		error: function (jqXHR, textStatus, errorThrown,response) 
		{
			alert('Internal error: ' + errorThrown);
	       },		  
   	}).done(function() 
 	{
	  	setTimeout(function()
	  	{
			  	$("#overlay").fadeOut(300);
		},500);
	});
}

$(window).on('beforeunload',function()
{
	
 	let url = window.location.pathname ;
 	let getUrl = window.location;
 	let premiumUrl = "/" + getUrl.pathname.split('/')[1] + "/" + getUrl.pathname.split('/')[2];
	let cname =  '/category/'+ $("#categoryName").val();
 	
 	if(url == '/inventor/add/invention')
 	{
 		if(localStorage.getItem('inventionkey') == 'true')
 		{
 			return 'Your changes may be discarded. Are you sure you want to leave this page?';
 		}
 	}
 	if(url == '/premium/vendor/sign-up' || url == '/free/vendor/sign-up' || url == '/pro/vendor/sign-up' || url == '/free/vendor/edit/profile' || url == '/pro/vendor/edit/profile' || url == '/vendor/edit/profile')
 	{

 		if(localStorage.getItem('vendorkey') == 'true')
 		{
 			return 'Your changes may be discarded. Are you sure you want to leave this page?';
 		}
 	}
 	if(premiumUrl == '/premium/vendor')
 	{
		let vendorId = $(".prebookmark ").data('vendor-id');
		if($("#add-rfq").val() == 'false')
		{
			timeSpendUpdate(vendorId);
		}
 		
 	}
 	if(url == '/publish')
 	{
 		if($("#send-rfq-btn").val() == 'false')
 		{
 			localStorage.removeItem('uploadedFiles');
 			return 'Your changes may be discarded. Are you sure you want to leave this page?';
 		}
 	}


});
function pageld() {
  alert("Page is loaded");
}
$(document).ready(function()
{
	let id = $('#loadpagedata').val();
	if(id == 'invention' || id == 'vendor')
	{
		let data = localStorage.getItem('newsletterSubscriptionModal');
		let type = localStorage.getItem('type');
		let vendorType = localStorage.getItem('vendorType');
		let email = localStorage.getItem('email');
		let name = localStorage.getItem('name');
		let password = localStorage.getItem('password');
		let category = localStorage.getItem('category');
		let referralCode = localStorage.getItem('referralCode');
		localStorage.clear();
		if(data != null)
		{
			localStorage.setItem('newsletterSubscriptionModal',data);
		}
		if(type != null)
		{
			localStorage.setItem('type',type);
		}
		if(vendorType != null)
		{
			localStorage.setItem('vendorType',vendorType);
		}
		if(email != null)
		{
			localStorage.setItem('email',email);
		}
		if(name != null)
		{
			localStorage.setItem('name',name);
		}
		if(password != null)
		{
			localStorage.setItem('password',password);
		}
		if(category != null)
		{
			localStorage.setItem('category',category);
		}
		if(referralCode != null)
		{
			localStorage.setItem('referralCode',referralCode);
		}
	}
	else
	{

	}
});


$(document).ready(function()
{
	let url = window.location.pathname ;
	let cname =  '/category/'+ $("#categoryName").val();
	
	if(url == cname)
	{
		setInterval(function()
		{
			let msg ='Send RFQ to vendors';
			let cat_id = $("#cuuid").val();
			let storageAllVendors = JSON.parse(localStorage.getItem('allSelectedVendors'));
			let vendorCount = 0;
			if(storageAllVendors != null)
			{
				for (let i = 0; i < storageAllVendors.length; i++)
				{
				 	if(storageAllVendors[i]['cuuid'] == cat_id)
				 	{
				 	    vendorCount = vendorCount + 1 ;
				 	}
				}
			}	
			if(vendorCount != 0)
			{
				msg = 'Send RFQ to '+ vendorCount + ' vendors ' ;

			}
			if(vendorCount > 0)
			{
				$('#selected-vendors').prop('disabled', false);
				$('#cart-vendors').css('display', "block");
				$('#selected-vendors').removeClass('vendor-disable-foot-btn');
				$('#selected-vendors').addClass('vendor-enable-foot-btn');
				$('#selected-vendors').html(msg);
				$('#cart-vendors').removeClass('vendor-disable-foot-btn');
				$('#cart-vendors').addClass('vendor-enable-foot-btn');
				$('.dummyRfqBtn').addClass('profileBtn');

			}
			else
			{
				$('#cart-vendors').css('display', "none");
				$('#selected-vendors').prop('disabled', true);
				$('#selected-vendors').addClass('vendor-disable-foot-btn');
				$('#selected-vendors').removeClass('vendor-enable-foot-btn');
				$('#cart-vendors').addClass('vendor-disable-foot-btn');
				$('#cart-vendors').removeClass('vendor-enable-foot-btn');
				$('#selected-vendors').html(msg);
				$('.dummyRfqBtn').removeClass('profileBtn');

			}
				
		},3000);
	}
});

$(document).ready(function()
{
	$('#proModal').on('hidden.bs.modal', function (e) 
	{
		let vendorId = $("#vendorId").val();
		$(document).ajaxSend(function() 
	  	{
		  	$("#overlay").fadeIn(300);　
	    });
 		$.ajax(
 		{
   			headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
    		data:{"_token": $("input[name='_token']").val(), "vendorId" :vendorId ,},
   			url: '/vendor/vistor-time',
   			type: 'POST',
   			success: function (ajaxResponse) 
   			{
	  			
			},
			error: function (jqXHR, textStatus, errorThrown,response) 
			{
				alert('Internal error: ' + errorThrown);
	        },		  
   		})
 		.done(function() 
 		{
		  	setTimeout(function()
		  	{
			  	$("#overlay").fadeOut(300);
		  	},500);
	  	});
	});
});

$(document).on("click", "#cart-vendors", function() 
{
    let category = $(".rfq-vendors").data('category');
    let vendors = localStorage.getItem("allSelectedVendors");
    $(document).ajaxSend(function() {
        $("#overlay").fadeIn(300);
    });
    $.ajax({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        url: '/cart/vendor/list',
        data: {
            "_token": $("input[name='_token']").val(),
            "category": category,
            "vendors": vendors,
            "cuuid": cuuid
        },
        type: 'post',
        dataType: 'json',
        success: function(response) {
            $("#list-cart-vendors").html(response.html);
            $("#list-cart-vendors").modal("show");

        }
    }).done(function() {
        setTimeout(function() {
            $("#overlay").fadeOut(300);
        }, 500);
    });
});

$(document).on("click", ".removeCartVendor", function() 
{
    let category = $(".removeCartVendor").data('category');
    let vendor = $(".removeCartVendor").data('vendor');
    let divID = "#vendor-" + vendor;
    let existingVendorEntries = JSON.parse(localStorage.getItem("allSelectedVendors"));
    if (existingVendorEntries == null) 
    {
        existingVendorEntries = [];
    }
    let temp = [];
    if (existingVendorEntries.length != 0) 
    {
        for (let i = 0; i < existingVendorEntries.length; i++) 
        {
            if (existingVendorEntries[i]['vid'] == vendor && existingVendorEntries[i]['cat_id'] == category) 
            {
                temp = existingVendorEntries[i];
                existingVendorEntries.splice(i, 1);
                localStorage.setItem("allSelectedVendors", JSON.stringify(existingVendorEntries));
                $(divID).remove();
            }
        }
    }
});

window.onload = function() 
{
    let url = window.location.pathname;
    let category = $("#scid").val();
    let cname =  '/category/'+ $("#categoryName").val();
    if (url == cname) 
    {
        let storageAllVendors = JSON.parse(localStorage.getItem('allSelectedVendors'));
        let vendorCount = 0;
        if (storageAllVendors != null) {
            for (let i = 0; i < storageAllVendors.length; i++) 
            {
                if (storageAllVendors[i]['cat_id'] == category) 
                {
                    vendorCount = vendorCount + 1;
                }
            }
        }
        if (vendorCount != 0) 
        {
            let vendors = localStorage.getItem("allSelectedVendors");
            $(document).ajaxSend(function() {
                $("#overlay").fadeIn(300);
            });
            $.ajax({
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                url: '/cart/vendor/list',
                data: {
                    "_token": $("input[name='_token']").val(),
                    "category": category,
                    "vendors": vendors,
            		"cuuid": cuuid
                },
                type: 'post',
                dataType: 'json',
                success: function(response) {
                    $("#list-cart-vendors").html(response.html);
                    $("#list-cart-vendors").modal("show");

                }
            }).done(function() {
                setTimeout(function() {
                    $("#overlay").fadeOut(300);
                }, 500);
            });

        }
    }

};

$(document).ready(function () 
{
    let keepAliveInterval = setInterval(checkSession, 1800000);
    function checkSession() 
    {
        $.ajax({
            url: '/keep-alive',
            type: 'GET',
            dataType: 'json',
            success: function (response) 
            {
                if (response.refreshPage) 
                {
                    clearInterval(keepAliveInterval);

                    const title = response.user === 0 ? 'Unfortunately, your session has expired.' : 'Unfortunately, your login session has ended.';
                    const text = response.user === 0 ? 'Please press OK to refresh the page.' : 'Please sign in again';
                    if (response.user != 0) 
                    {
                    	Swal.fire({
                    	    title: title,
                    	    text: text,
                    	    icon: 'warning',
                    	    confirmButtonText: 'OK'
                    	}).then(function () 
                    	{
                    	   window.location.href = '/';
                    	});
                    }
                } 
                else if (response.refreshWarning === 1 || response.refreshWarning === 2) 
                {
                    const warningTitle = response.refreshWarning === 1 ? '1st warning' : '2nd warning';
                    Swal.fire(
                    {
                        title: warningTitle,
                        text: "Click 'OK' to refresh the CSRF token.",
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonText: 'OK',
                        cancelButtonText: 'Cancel',
                    }).then(function (result) 
                    {
                        if (result.value) 
                        {
                            $.ajax(
                            {
                                url: '/login/session/update',
                                method: 'get',
                                data: {
                                    '_token': $("input[name='_token']").val()
                                },
                                success: function (data) 
                                {
                                }
                            });
                            window.location.reload();
                        }
                    });
                } 
                else 
                {
                }

            },
            error: function (jqXHR, textStatus, errorThrown) {
                alert('Internal error: ' + errorThrown);
            },
        });
    }
});


$(document).ready(function() 
{
	let url = window.location.pathname ;
 	let getUrl = window.location;
 	let currentUrl = "/" + getUrl.pathname.split('/')[1];
 	let matchUrl = '/invitation-link';
 	if(currentUrl == matchUrl)
 	{
 		let refKey = getUrl.pathname.split('/')[2];
 		sessionStorage.setItem("referralCode", refKey);
 	}
 	let registerUrl = '/register'
 	if(currentUrl == registerUrl)
 	{
 		let refKey = sessionStorage.getItem("referralCode");
 		if(refKey != null)
 		{
 			$(document).ajaxSend(function() 
		  	{
			  	$("#overlay").fadeIn(300);　
		    });
			$.ajax(
			{
				url: '/vendor/referralCode/check/' + refKey,
				type: 'GET',
				dataType: 'json',
				success: function(response)
				{
					$("#vemail").val(response.email);
	 				$("#referralCode").val(response.referralCode);
	 				localStorage.setItem("referralCode", response.referralCode);
				}
			}).done(function() 
	 		{
			  	setTimeout(function()
			  	{
				  	$("#overlay").fadeOut(300);
			  	},500);
		  	});
	 			
	 		$('.vendor-signup-tab').css('display','block');
	 		$('#btnradio1"').prop("checked", false);
	 		$('#btnradio2"').prop("checked", true);
	 		$('.inventor-signup-tab').css('display','none');
	 		localStorage.setItem("type", 'vendor');
 		}
 		
 	}
});

